/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


'use strict';
window.Mogo = window.Mogo || {};
window.Mogo.vars = window.Mogo.vars || {};
window.Mogo.methods = window.Mogo.methods || {};
window.Mogo.section = window.Mogo.section || {};

var ua = window.navigator.userAgent.toLowerCase();
window.Mogo.ie = (/trident/gi).test(ua) || (/msie/gi).test(ua);

/*================ MOGO ================*/
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.layout = function() {
    var $sections_full = $('.tt-layout__section--full-js');

    if($sections_full.length) {
        var $cont = $('.tt-layout__content > .container');

        function calculate(animate) {
            var margin = ($cont[0].getBoundingClientRect().left + parseInt($cont.css('padding-left'), 10)) * -1,
                method = animate ? 'animate' : 'css';

            $sections_full[method]({
                'margin-left': margin,
                'margin-right': margin
            }, {
                duration: 300
            });
        };

        $(window).on('resize.layout', function() {
            calculate();
        });

        $(function() {
            calculate(true);
        });
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.preloader = function() {
    var $preloader = $('.tt-preloader'),
        delay = 0;

    if($preloader.length) {
        $(window).on('load', function() {
            setTimeout(function() {
                $preloader.on('transitionend', function() {
                    $preloader.remove();
                });
                $preloader.addClass('tt-loaded');
            }, delay);
        });
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.logoCurtain = {
    section: {
        init: function() {
            var _self = this,
                $logo = $('.tt-logo.tt-logo__curtain');

            if($logo) {
                if(!this.is_loaded) {
                    $(document).on('ready.logocurtain', function() {
                        $logo.addClass('tt-logo__curtain-hide');

                        _self.is_loaded = true;
                    });
                } else {
                    $logo.addClass('tt-logo__curtain-hide');
                }
            }
        },
        is_loaded: false,
        destroy: function() {
            $(window).unbind('load.logocurtain');
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.masonryBlog = function() {
    jQueryBridget( 'masonry', window.Masonry, $ );

    var $masonry_grid = $('.tt-masonry'),
        masonry,
        params = {
            itemSelector: '[class^="col-"]'
        };

    masonry = $masonry_grid.masonry(params).css({ 'visibility': 'visible' });

    $(window).on('load', function() {
        masonry.masonry('layout');
    });

    $masonry_grid.imagesLoaded().progress(function() {
        masonry.masonry('layout');
    });
};

if(!is_iframe) {
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.player = function() {
    var $player = $('.tt-player');

    if(!$player.length) return;

    var player = $player.get(0),
        interval_vol,
        wind_w = window.innerWidth,
        on_audio = true || $.cookie('newsletter'),
        random,
        media = [
            'media/audio-01.mp3',
            'media/audio-02.mp3',
            'media/audio-03.mp3',
            'media/audio-04.mp3',
            'media/audio-05.mp3',
            'media/audio-06.mp3',
            'media/audio-07.mp3',
            'media/audio-08.mp3',
            'media/audio-09.mp3',
            'media/audio-10.mp3'
        ];

    if(on_audio !== 'off' && wind_w > 1024) {
        function randomInteger(min, max) {
            var rand = min - 0.5 + Math.random() * (max - min + 1);
            rand = Math.round(rand);
            return rand;
        }

        random = randomInteger(0, media.length - 1);

        $player.attr('src', media[random]);

        player.volume=0.2;

        player.play();

        interval_vol = setInterval(function () {
            player.volume += 0.01;
            if(player.volume >= 0.6) clearInterval(interval_vol);
        }, 300);
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.lazyLoad = function() {
    var $images = $('img[data-srcset]');

    $images.Lazy({
        effect: 'fadeIn',
        scrollDirection: 'vertical'
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.newsletterPopup = function() {
    var newsletter_popup = '.tt-newsletter-popup',
        $newsletter_popup = $(newsletter_popup),
        $checkbox_show_popup = $newsletter_popup.find('.tt-newsletter-popup__show_popup input'),
        show_once = $newsletter_popup.data('show-once') || false,
        delay = +$newsletter_popup.data('delay') || 2,
        cookies_life = +$newsletter_popup.data('cookies-life') || 3;

    setTimeout(function () {
        var cookie_news = $.cookie('newsletter');

        if($(newsletter_popup + '[data-active="true"]').length && cookie_news !== 'off') {
            $.magnificPopup.open({
                mainClass: 'mfp-with-zoom',
                removalDelay: 300,
                closeMarkup: '<button title="%title%" type="button" class="mfp-close icon-cancel"></button>',
                items: [
                    {
                        src: '.tt-newsletter-popup',
                        type: 'inline'
                    }
                ],
                callbacks: {
                    close: function() {
                        if(show_once || (!show_once && $checkbox_show_popup.is(':checked'))) {
                            var date = new Date(),
                                timer = 24 * 60 * 60 * 1000 * cookies_life;

                            date.setTime(date.getTime() + timer);

                            $.cookie('newsletter', 'off', {
                                expires: date,
                                path: '/'
                            });
                        }
                    }
                }
            });
        }
    }, delay * 1000);
};
}
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.currency = {
    construct: function() {
        this.dom = {
            $currencies: $('#currencies'),
            $current: $('#tt-current-currency')
        };
    },
    init: function() {
        Mogo.currency = new this.construct;
    }
};

Mogo.currency.construct.prototype = $.extend({}, Mogo.currency.construct.prototype, {
    load: function() {
        var _self = this,
            $currencies = this.dom.$currencies,
            $currentCurrency = this.dom.$current,
            $resetActiveCurrency = $currencies.find('li'),
            cookieCurrency;

        try {
            cookieCurrency = Currency.cookie.read();
        } catch(err) {}

        $('span.money span.money').each(function () {
            $(this).parents('span.money').removeClass('money');
        });

        $('span.money').each(function () {
            $(this).attr('data-currency-' + Currency.shopCurrency, $(this).html());
        });

        if (cookieCurrency == null) {
            if (Currency.shopCurrency !== Currency.defaultCurrency) {
                Currency.convertAll(Currency.shopCurrency, Currency.defaultCurrency);
            } else {
                Currency.currentCurrency = Currency.defaultCurrency;
            }
        } else if (cookieCurrency === Currency.shopCurrency) {
            Currency.currentCurrency = Currency.shopCurrency;
        } else {
            Currency.convertAll(Currency.shopCurrency, cookieCurrency);
            $currentCurrency.html(cookieCurrency);
            $resetActiveCurrency.find('a').each(function () {
                var $this = $(this);

                if ($this.data('currency-code') == cookieCurrency) {
                    $this.parent().addClass('active');
                } else {
                    $this.parent().removeClass('active');
                }
            });
        }
        
        if($('body').data('currency-multiple')) {
            _self.handlers();
        }
    },
    handlers: function() {
        var _self = this;

        $('#currencies li a').on('click', function (e) {
            var $this = $(this),
                $currencies = _self.dom.$currencies,
                $currentCurrency = _self.dom.$current,
                $resetActiveCurrency = $currencies.find('li'),
                newCurrency;

            newCurrency = $this.data('currency-code');
            $resetActiveCurrency.removeClass('active');

            if (newCurrency == Currency.currentCurrency) {
                Currency.convertAll(Currency.shopCurrency, newCurrency);
            } else {
                Currency.convertAll(Currency.currentCurrency, newCurrency);
            }

            $this.parent().addClass('active');
            $currentCurrency.html(newCurrency);
            $('.tt-header__settings > i').trigger('togglelist.close');

            e.preventDefault();
            return false;
        });
    },
    update: function() {
        var $currencies = this.dom.$currencies;

        $currencies.find('li.active > a').trigger('click');
    }
});
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */


Mogo.stickyHeader = {
    section: {
        init: function() {
            var $sticky = $('.tt-header--sticky'),
                effect = $sticky.attr('data-sticky-effect') || 1;

            if ($sticky.length) {
                var params = {
                    bp: 1024,
                    mobile: {
                        sticky: '.tt-header__nav',
                        limit: 'bottom',
                        fade: true,
                        duration: 300
                    }
                };

                if ($sticky.hasClass('tt-header--build-01') || $sticky.hasClass('tt-header--build-04')) {
                    $.extend(true, params, {
                        desktop: {
                            sticky: '.tt-header__content',
                            height: 60
                        }
                    });
                } else if ($sticky.hasClass('tt-header--build-02') || $sticky.hasClass('tt-header--build-03')) {
                    $.extend(true, params, {
                        desktop: {
                            sticky: '.tt-header__menu',
                            move: [
                                {
                                    elem: '.tt-header__sidebar',
                                    to: '.tt-header__menu',
                                    method: 'append'
                                }
                            ]
                        },
                        mobile: {
                            move: [
                                {
                                    elem: '.tt-header__menu',
                                    to: '.tt-header__nav',
                                    method: 'append'
                                }
                            ]
                        }
                    });
                }

                if(effect === '2') {
                    $.extend(true, params, {
                        desktop: {
                            limit: 'bottom',
                            fade: true,
                            duration: 300
                        }
                    });
                }

                var stickyHeader = {
                    _create: function() {
                        var _ = this,
                            $elem = this.bindings,
                            $sticky_m = $elem.find(this.options.mobile.sticky),
                            $sticky_d = $elem.find(this.options.desktop.sticky),
                            $spacer_m = $('<div>').addClass('tt-header__spacer tt-header__spacer--m').insertBefore($sticky_m),
                            $spacer_d = $('<div>').addClass('tt-header__spacer tt-header__spacer--d').insertBefore($sticky_d);

                        this.sticky_class = 'tt-header__sticky';

                        function fix() {
                            _._fix(_.$sticky, _.$spacer);
                            _._move(_.options[_.bp]);
                        };

                        function unfix() {
                            _._unfix(_.$sticky, _.$spacer);
                            _._return(_.options[_.bp]);
                        };

                        function on_resize() {
                            var w = window.innerWidth,
                                is_desktop = w > _.options.bp;

                            _.bp = is_desktop ? 'desktop' : 'mobile';
                            _.$sticky = is_desktop ? $sticky_d : $sticky_m;
                            _.$spacer = is_desktop ? $spacer_d : $spacer_m;

                            if (is_desktop) {
                                $spacer_m.removeClass('tt-header__spacer--visible');
                                $spacer_d.addClass('tt-header__spacer--visible');

                                if ($sticky_m.hasClass(_.sticky_class)) {
                                    _._unfix($sticky_m, $spacer_m);
                                    _._return(_.options.mobile);
                                }
                            } else {
                                $spacer_d.removeClass('tt-header__spacer--visible');
                                $spacer_m.addClass('tt-header__spacer--visible');

                                if ($sticky_d.hasClass(_.sticky_class)) {
                                    _._unfix($sticky_d, $spacer_d);
                                    _._return(_.options.desktop);
                                }
                            }
                        };

                        function on_scroll() {
                            var limit = _.options[_.bp].limit ? _.options[_.bp].limit : 0,
                                spacer_pos = _.$spacer[0].getBoundingClientRect();

                            if (limit === 'bottom') {
                                limit = _.$sticky.hasClass(_.sticky_class) ? _.$spacer.innerHeight() : _.$sticky.innerHeight();
                            }

                            limit *= -1;

                            if (spacer_pos.top < limit) {
                                if (!_.$sticky.hasClass(_.sticky_class)) {
                                    fix();
                                }

                                if(!Mogo.ie) {
                                    _._check_height(_.$sticky, _.options[_.bp]);
                                }
                            } else {
                                if (_.$sticky.hasClass(_.sticky_class)) {
                                    unfix();
                                }
                            }
                        };

                        on_resize();
                        on_scroll();

                        $(window).on({
                            'resize.stickyHeader': function() {
                                on_resize();
                                on_scroll();
                            },
                            'scroll.stickyHeader': on_scroll
                        });
                    },
                    _fix: function($sticky, $spacer) {
                        var height = $sticky.innerHeight();

                        $spacer.height(height);

                        if(this.options[this.bp].fade) {
                            $sticky.css({ 'opacity': 0 }).velocity({ 'opacity': 1 }, this.options[this.bp].fade || 300);
                        }

                        $sticky.addClass(this.sticky_class);
                    },
                    _unfix: function($sticky, $spacer) {
                        $spacer.removeAttr('style');

                        if(this.options[this.bp].fade) {
                            $sticky.velocity('stop', true);
                        }

                        $sticky.removeAttr('style').removeClass(this.sticky_class);
                    },
                    _move: function(obj) {
                        if (!obj.move) return;

                        $.each(obj.move, function() {
                            var $elem = $(this.elem),
                                $to = $(this.to),
                                method = this.method || 'append';

                            this.$elem = $elem;
                            this.$parent = $elem.parent();

                            $to[method]($elem);
                        });
                    },
                    _return: function(obj) {
                        if (!obj.move) return;

                        $.each(obj.move, function() {
                            var method = this.method || 'append';

                            this.$parent[method](this.$elem);
                            this.$elem = null;
                            this.$parent = null;
                        });
                    },
                    _check_height: function($sticky, obj) {
                        if(!obj.height) return;

                        var spacer_pos = this.$spacer[0].getBoundingClientRect(),
                            height = spacer_pos.bottom <= obj.height ? obj.height : spacer_pos.bottom;

                        $sticky.css({ 'min-height': height });
                    },
                    getStickyHeight: function() {
                        return this.options[this.bp].height || $(this.options[this.bp].sticky).innerHeight();
                    },
                    destroy: function() {
                        $(window).unbind('resize.stickyHeader scroll.stickyHeader');

                        $.Widget.prototype.destroy.call(this);
                    }
                };

                $.widget('ui.stickyHeader', stickyHeader);

                $sticky.stickyHeader(params);

                this.$sticky = $sticky;
            }
        },
        destroy: function() {
            if (this.$sticky) {
                this.$sticky.stickyHeader('destroy');
            }
        }
    }
};



/*DOCUMENTATION*/

//params example
/*
{
 bp: 1024,
    mobile: {
        sticky: '.tt-header__nav',
        limit: 400,
        fade: true,
        duration: 400
    },
    desktop: {
        sticky: '.tt-header__menu',
        height: 60,
        move: [
            {
                elem: '.tt-header__sidebar',
                to: '.tt-header__menu',
                method: 'append'
            }
        ]
    }
}

//params info
bp - responsive breakpoint (number)
mobile, desktop - breakpoint params (object)
bp.sticky - sticky element (selector)
bp.limit - breakpoint to start sticky (number, 'bottom')
bp.height - change sticky element height (number)
bp.fade - fade effect (bool)
bp.duration - effects duration (number)
bp.move - move elements inside sticky (array of objects)
bp.move.elem - items that are moved (selector)
bp.move.to - element to which to move (selector)
bp.move.method - jquery method move (string)
*/

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.headerVariables = {
    section: {
        init: function() {
            Mogo.vars = {
                $header: $('.tt-header'),
                $options: $('.tt-header__options'),
                $tonyMenu_top: $('.TonyM.TonyM--header'),
                $btn_menu_toggle: $('.tt-header__btn-menu'),
                $settings: $('.tt-header__settings'),
                $settings_btn: $('.tt-header__btn-settings'),
                $user: $('.tt-header__user'),
                $user_btn: $('.tt-header__btn-user'),
                $cart: $('.tt-header__cart'),
                $cart_btn: $('.tt-header__btn-cart'),
                $search_btn: $('.tt-header__btn-open-search'),
                $search_close_btn: $('.tt-header__btn-close-search'),
                $search_input: $('.tt-header__search-form input'),
                $search_dropdown: $('.tt-header__search-dropdown')
            };
        },
        destroy: function() {
            Mogo.vars = null;
        }
    }
};

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.megamenu = {
    section: {
        init: function() {

            function closeAllDD() {
                Mogo.vars.$user_btn.trigger('togglelist.close');
                Mogo.vars.$cart_btn.trigger('togglelist.close');
                Mogo.vars.$search_close_btn.trigger('search.close');
                Mogo.vars.$settings_btn.trigger('togglelist.close');
            };

            Mogo.vars.$tonyMenu_top.TonyM({
                btn: Mogo.vars.$btn_menu_toggle,
                beforeOpenTM: function() {
                    closeAllDD();
                },
                beforeOpenMM: function() {
                    closeAllDD();
                }
            });
        },
        destroy: function() {
            Mogo.vars.$tonyMenu_top.TonyM('destroy');
        }
    }
};

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.headerDropdowns = {
    section: {
        init: function() {
            var $body = $('body'),
                scrollW,
                $scrlBl = $('<div>').css({
                    overflowY: 'scroll',
                    width: '50px',
                    height: '50px',
                    visibility: 'hidden'
                });

            $body.append($scrlBl);
            scrollW = $scrlBl[0].offsetWidth - $scrlBl[0].clientWidth;
            $scrlBl.remove();

            $.fn.toggleList = function(options) {
                var $elem = $(this),
                    $options = $('.tt-header__options'),
                    breakpoint = 1024,
                    duration = options.duration || 500,
                    animate = false;

                options.$btn.on('click', function (e) {
                    if(animate) return;
                    animate = true;

                    var wind_w = window.innerWidth,
                        mobile = wind_w <= breakpoint;

                    $elem.toggleClass('tt-header__option-open');

                    if($elem.hasClass('tt-header__option-open')) {
                        var wind_h = window.innerHeight;

                        if(options.beforeOpen) options.beforeOpen();

                        $elem.removeAttr('style');

                        function open() {
                            $elem.perfectScrollbar();

                            options.$btn.addClass('active');

                            $elem.velocity('stop').velocity('slideDown', {
                                duration: duration,
                                complete: function () {
                                    var save_wind_w = window.innerWidth;

                                    $(window).on('resize.popupclose', function () {
                                        var wind_w = window.innerWidth,
                                            wind_h = window.innerHeight;

                                        if(save_wind_w != wind_w) {
                                            closeList();
                                        } else if(wind_h <= breakpoint) {
                                            $elem.height(wind_h - $options[0].getBoundingClientRect().bottom);
                                        }
                                    });

                                    if(options.afterOpen) options.afterOpen();
                                    animate = false;
                                }
                            });
                        };

                        if(mobile) {
                            $elem.height(wind_h - $options[0].getBoundingClientRect().bottom);

                            $body.addClass('ttg-ovf-hidden').css({ 'padding-right': scrollW });
                            $('.tt-header__sticky .tt-header__sidebar').css({ 'padding-right': scrollW });

                            open();
                        } else {
                            var options_b = $('.tt-header__options').get(0).getBoundingClientRect().bottom;

                            $elem.css({ 'max-height': wind_h - options_b });

                            open();
                        }

                    } else {
                        if(options.beforeClose) options.beforeClose();

                        $elem.perfectScrollbar('destroy').removeClass('ps');

                        options.$btn.removeClass('active');

                        $(window).unbind('resize.popupclose');

                        $elem.velocity('stop').velocity('slideUp', {
                            duration: duration,
                            complete: function () {
                                if(mobile) {
                                    $body.removeClass('ttg-ovf-hidden').removeAttr('style');
                                    $('.tt-header__sticky .tt-header__sidebar').removeAttr('style');
                                }

                                if(options.afterClose) options.afterClose();
                                animate = false;
                            }
                        });
                    }

                    e.preventDefault();
                    return false;
                });

                function closeList() {
                    if($elem.hasClass('tt-header__option-open')) {
                        $elem.removeAttr('style').removeClass('tt-header__option-open');
                        $body.removeClass('ttg-ovf-hidden').removeAttr('style');
                        options.$btn.removeClass('active');
                    }
                };

                options.$btn.on('togglelist.close', function () {
                    closeList();
                });
            };

            Mogo.vars.$settings.toggleList({
                $btn: Mogo.vars.$settings_btn,
                duration: 400,
                beforeOpen: function () {
                    Mogo.vars.$user_btn.trigger('togglelist.close');
                    Mogo.vars.$cart_btn.trigger('togglelist.close');
                    Mogo.vars.$search_close_btn.trigger('search.close');
                    Mogo.vars.$tonyMenu_top.TonyM('hideTM', false, false, true);
                }
            });

            Mogo.vars.$user.toggleList({
                $btn: Mogo.vars.$user_btn,
                duration: 400,
                beforeOpen: function () {
                    Mogo.vars.$settings_btn.trigger('togglelist.close');
                    Mogo.vars.$cart_btn.trigger('togglelist.close');
                    Mogo.vars.$search_close_btn.trigger('search.close');
                    Mogo.vars.$tonyMenu_top.TonyM('hideTM', false, false, true);
                }
            });

            Mogo.vars.$cart.toggleList({
                $btn: Mogo.vars.$cart_btn,
                duration: 400,
                beforeOpen: function () {
                    Mogo.vars.$settings_btn.trigger('togglelist.close');
                    Mogo.vars.$user_btn.trigger('togglelist.close');
                    Mogo.vars.$search_close_btn.trigger('search.close');
                    Mogo.vars.$tonyMenu_top.TonyM('hideTM', false, false, true);
                    Mogo.vars.$cart.find('ul').addClass('ttg-loading');
                },
                afterOpen: function () {
                    Mogo.vars.$cart.find('ul').removeClass('ttg-loading');
                },
                afterClose: function () {
                    Mogo.vars.$cart.find('ul').removeClass('ttg-loading');
                }
            });
        },
        destroy: function() {
            Mogo.vars.$settings.off();
            Mogo.vars.$user.off();
            Mogo.vars.$cart.off();
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.search = {
    section: {
        init: function() {
            var search_empty = '<div class="tt-header__search-empty"><p>' + theme.strings.searchEmpty + '</p></div>',
                search_loading = '<div class="tt-header__search-empty"><p>' + theme.strings.searchLoadin + '</p></div>',
                search_data,
                ajax_request,
                bp = 1024;

            Mogo.vars.$search_btn.on('click', function (e) {
                Mogo.vars.$settings_btn.trigger('togglelist.close');
                Mogo.vars.$user_btn.trigger('togglelist.close');
                Mogo.vars.$cart_btn.trigger('togglelist.close');
                Mogo.vars.$tonyMenu_top.TonyM('hideTM', false, false, true);
                Mogo.vars.$search_dropdown.perfectScrollbar();

                function action() {
                    Mogo.vars.$search_dropdown.removeClass('tt-header__search-dropdown--open');
                    Mogo.vars.$search_dropdown.html(search_loading);
                    Mogo.vars.$header.addClass('tt-header--search');
                    Mogo.vars.$search_input.val('').focus();
                };

                action();

                e.preventDefault();
                return false;
            });

            Mogo.vars.$search_close_btn.on('click search.close', function (e) {
                Mogo.vars.$header.removeClass('tt-header--search');
                Mogo.vars.$search_dropdown.perfectScrollbar('destroy').removeClass('ps');
                $(window).unbind('resize.search scroll.search');

                e.preventDefault();
                return false;
            });

            function debounce(func, wait, immediate) {
                var timeout;
                return function() {
                    var context = this, args = arguments;
                    var later = function() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            };

            function send_ajax(obj) {
                if (ajax_request) {
                    ajax_request.abort();
                }
                var search_string = obj.search_string;

                ajax_request = $.ajax($.extend({
                    url: '/search',
                    dataType: "json",
                    type: 'POST',
                    data: { q: search_string, view: 'json'},
                    timeout: 2000,
                    cache: false,
                    success: function (data) {
                        Mogo.vars.$search_dropdown.html(searchResultsToHtml(data,search_string)).removeClass('ttg-loading');
                        resizeSearch();
                    },
                    error: function (jqXHR, exception) {

                        if (jqXHR.status === 0) {
                            console.log('Not connect.\n Verify Network.');
                        } else if (jqXHR.status == 404) {
                            console.log('Requested page not found. [404]');
                        } else if (jqXHR.status == 500) {
                            console.log('Internal Server Error [500].');
                        } else if (exception === 'parsererror') {
                            console.log(jqXHR.responseText);
                        } else if (exception === 'timeout') {
                            console.log('Time out error.');
                        } else if (exception === 'abort') {
                            console.log('Ajax request aborted.');
                        } else {
                            console.log('Uncaught Error.\n' + jqXHR.responseText);
                        }
                    }
                }, obj));
            };

            var myEfficientFn = debounce(function() {
                var $this = $(this),
                    data = $this.val();

                if(search_data === data) return;

                search_data = data;

                Mogo.vars.$search_dropdown.addClass('tt-header__search-dropdown--open ttg-loading');

                send_ajax({ search_string: data });
            }, 500);

            Mogo.vars.$search_input.on('keyup', function (e) {
                if(e.keyCode === 27) {
                    Mogo.vars.$search_close_btn.trigger('search.close');
                    return;
                }

                myEfficientFn.call(this);
            });

            function resizeSearch() {
                function _func() {
                    var $options = $('.tt-header__options'),
                        options_b = $options.get(0).getBoundingClientRect().bottom,
                        wind_h = window.innerHeight;

                    Mogo.vars.$search_dropdown.css({ 'max-height': wind_h - options_b });
                    Mogo.vars.$search_dropdown.perfectScrollbar('update');
                };

                _func();
                $(window).on('resize.search scroll.search', _func);
            };

            function searchResultsToHtml (resultsInJson, search_string) {
                var html = '',
                    searchSeeAll = theme.strings.searchSeeAll;

                if(resultsInJson.results_count < 1) {
                    html = search_empty;
                } else {
                    $(resultsInJson.results).each(function (key, value) {
                        html += '<div>';
                        html += 	'<a href="' + value.url + '"><img src="' + value.thumbnail + '" srcset="' + value.thumbnail + ' 1x, ' + value.thumbnail2x + ' 2x" class="colorize-bd2 colorize-main-bd-h" alt="value.title"></a>';
                        html += 	'<p><a href="' + value.url + '">' + value.title + '</a></p>';
                        html += '</div>';
                    });

                    if (resultsInJson.results_count > 3) {
                        html += '<div>';
                        searchSeeAll = searchSeeAll.replace('{{count}}',resultsInJson.results_count);
                        html += 	'<p><a href="/search?q=' + search_string + '">' + searchSeeAll + '</a></p>';
                        html += '</div>';
                    }
                }

                return html
            }
        },
        destroy: function() {
            Mogo.vars.$search_input.off();
            Mogo.vars.$search_btn.off();
            Mogo.vars.$search_close_btn.off();
            $(window).unbind('resize.search scroll.search');
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.listDropdown = {
    section: {
        init: function() {
            var duration = 500,
                $list_toggle = $('.tt-list-toggle'),
                $li = $list_toggle.find('> *:not(a)'),
                $li_open = $li.filter('.tt-list-toggle__open'),
                $li_next;

            $li.each(function () {
                var $this = $(this);

                if($this.find('> *:not(a)').length) $this.addClass('tt-list-toggle__next');
            });

            $li_next = $list_toggle.find('.tt-list-toggle__next');

            this.$li_next = $li_next.find('> a');

            $li_next.find('> a').on('click', function (e) {
                var $this = $(this),
                    $li = $this.parent(),
                    $content = $li.find('> *:not(a)');

                if($content.length) {
                    $li.toggleClass('tt-list-toggle__open');


                    if ($li.hasClass('tt-list-toggle__open')) $content.velocity('stop').removeAttr('style').velocity( 'slideDown', duration);
                    else $content.velocity('stop').velocity( 'slideUp', duration);

                    e.preventDefault();
                    return false;
                }
            });

            $li_open.find('> *:not(a)').show();
        },
        destroy: function() {
            this.$li_next.off();
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.counter = function() {
    var counter = '.tt-counter';

    $(document).on('click', counter + ' .tt-counter__control span', function (e) {
        var $this = $(this),
            $counter = $this.parents('.tt-counter'),
            $settings = $counter.find('.tt-counter__settings'),
            $input = $counter.find('input'),
            min_val = $settings.attr('data-min') || $counter.attr('data-min') || 1,
            max_val = $settings.attr('data-max') || $counter.attr('data-max') || Infinity,
            direction = $(this).attr('data-direction'),
            val = +$input.val(),
            set_val;

        if(!$.isNumeric(val)) {
            $input.val(min_val);
            e.preventDefault();
            return false;
        }

        if(direction === 'next') {
            set_val = ++val;
        } else if(direction === 'prev') {
            set_val = --val;
        }

        if(set_val < min_val) {
            set_val = min_val;

            e.stopPropagation();
        } else if(set_val > max_val) {
            set_val = max_val;

            e.stopPropagation();
        }

        if(set_val < 0) set_val = 0;

        $input.val(set_val);
        $input.trigger('customchange');
    });

    $(document).on('keydown', counter + ' input', function (e) {
        var keyArr = [8, 9, 27, 37, 38, 39, 40, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];

        if($.inArray(e.keyCode, keyArr) === -1) {
            e.preventDefault();
            return false;
        }
    });

    $(document).on('focus', counter + ' input', function (e) {
        $(this).select();
    });

    $(document).on('blur', counter + ' input', function (e) {
        var $this = $(this),
            $input = $this,
            val = +$input.val(),
            $counter = $this.parents('.tt-counter'),
            min_val = $counter.attr('data-min') || 1,
            max_val = $counter.attr('data-max') || Infinity;

        if(!$.isNumeric(val)) {
            $input.val(min_val);
			$input.trigger('customchange');
		} else if(val < min_val) {
            $input.val(min_val);
			$input.trigger('customchange');
		} else if(val > max_val) {
            $input.val(max_val);
			$input.trigger('customchange');
		}
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.toggleHeaderInfo = function() {
    var $btn = $('.tt-header__btn-info'),
        $info = $('.tt-header__tape'),
        dur = 400,
        breakpoint = 1024;

    $btn.on('click', function() {
        $btn.toggleClass('tt-header__btn-info--open');

        if($btn.hasClass('tt-header__btn-info--open')) {
            $info.velocity('stop').removeAttr('style').velocity( 'slideDown', dur);

            $(window).on('resize.headerinfo', function() {
                if(window.innerWidth > breakpoint) {
                    if($btn.hasClass('tt-header__btn-info--open')) {
                        $btn.removeClass('tt-header__btn-info--open');
                        $info.velocity('stop').removeAttr('style');
                    }
                }
            });
        } else {
            $info.velocity('stop').velocity( 'slideUp', {
                duration: dur,
                complete: function() {
                    $info.removeAttr('style');
                    $(window).on('resize.headerinfo');
                }
            });
        }
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.revolutionSlider = {
    resizeRev: function (options, new_rev_obj, bp_arr) {
        if(!options.slider || !options.breakpoints) return false;

        var slider = options.slider,
            breakpoints = options.breakpoints,
            fullscreen_BP = options.fullscreen_BP || false,
            new_rev_obj = new_rev_obj || {},
            bp_arr = bp_arr || [],
            rev_obj = {};

        $.extend(rev_obj, new_rev_obj);

        var get_current_bp = function() {
            var wind_W = window.innerWidth;

            for(var i = 0; i < breakpoints.length; i++) {
                var bp = breakpoints[i];

                if(!breakpoints.length) return false;

                if(wind_W <= bp) {
                    if(i === 0) {
                        return bp;
                    } else {
                        if(bp > breakpoints[i - 1])
                            return bp;
                    }
                } else if(wind_W > bp && i === breakpoints.length - 1)
                    return Infinity;
            }
            return false;
        };

        var $slider = $(slider),
            $sliderWrap = $slider.parent(),
            $sliderCont = $sliderWrap.parent(),
            $sliderWrapCopy = $sliderWrap.clone(),
            revapi,
            bp = get_current_bp();

        if(!$slider.length) return false;

        var start_Rev = function($slider, bp) {
            var wind_W = window.innerWidth,
                rev_settings_obj = {},
                rev_screen_obj = {},
                set_rev_obj = {};

            if(fullscreen_BP) {
                var full_width = (wind_W >= fullscreen_BP) ? 'off' : 'on',
                    full_screen = (wind_W >= fullscreen_BP) ? 'on' : 'off',
                    sliderLayout = (wind_W >= fullscreen_BP) ? 'fullscreen' : 'fullwidth';

                rev_screen_obj = {
                    fullWidth: full_width,
                    fullScreen: full_screen,
                    sliderLayout: sliderLayout
                };
            }

            if(bp_arr.length) {
                for(var i = 0; i < bp_arr.length; i++) {
                    var this_obj = bp_arr[i];

                    if(this_obj.bp && this_obj.bp.length === 2 && this_obj.bp[0] < this_obj.bp[1]) {
                        var from = this_obj.bp[0],
                            to = this_obj.bp[1];

                        if(from <= bp && to >= bp) {
                            for(var key in this_obj) {
                                if(key !== 'bp')
                                    rev_settings_obj[key] = this_obj[key];
                            }
                        }
                    }
                }
            }

            $.extend(set_rev_obj, rev_obj, rev_settings_obj, rev_screen_obj);

            revapi = $slider.show().revolution(set_rev_obj);

            revapi.one('revolution.slide.onloaded', function() {
                $slider.css({visibility: 'visible'});

                $(options.functions).each(function() {
                    this.call($slider);
                });
            });

            Mogo.revolutionSlider.revapi = revapi;
        };

        start_Rev($slider, bp);

        var restart_Rev = function(current_bp) {
            if(!$($slider).hasClass('revslider-initialised')) return;

            bp = current_bp || 0;
            revapi.revkill();
            $sliderCont.append($sliderWrapCopy.clone());
            $slider = $sliderCont.find(options.slider);
            start_Rev($slider, bp);
        };

        function endResize(func) {
            var windWidth = window.innerWidth,
                interval;

            interval = setInterval(function() {
                var windWidthInterval = window.innerWidth;
                if(windWidth === windWidthInterval) {
                    setTimeout(function() {
                        func();
                    }, 200);
                }
                clearInterval(interval);
            }, 100);
        };

        $(window).on('resize', function() {
            endResize(function() {
                var current_bp = get_current_bp();
                if(current_bp !== bp)
                    restart_Rev(current_bp);
            })
        });
    },
    section: {
        init: function() {
            var $slider = $('.tt-sr'),
                $header = $('.tt-header'),
                layout = $slider.attr('data-layout'),
                breakpoints = $slider.attr('data-breakpoints'),
                heights = $slider.attr('data-heights'),
                offset_top = !$header.hasClass('tt-header__transparent'),
                rtl = $('body').attr('dir') === 'rtl';

            breakpoints = breakpoints ? breakpoints.split('|') : false;
            heights = heights ? heights.split('|') : 960;

            function ArraySetTypeofNumb(obj) {
                for(var i = 0; i < obj.length; i++) {
                    obj[i] = +obj[i];
                }
            };

            ArraySetTypeofNumb(breakpoints);
            ArraySetTypeofNumb(heights);

            if($slider.length) {
                var revolution_params = $slider.data('tt-params'),
                    revolution_obj = {
                        sliderLayout: layout || 'fullscreen',
                        fullScreenOffsetContainer: (offset_top) ? 'header' : false,
                        delay: 10000,
                        startwidth: 1720,
                        gridwidth: 1720,
                        responsiveLevels: breakpoints,
                        gridheight: heights,
                        shadow: 0,
                        spinner: 'off',
                        shuffle: "off",
                        startWithSlide: 0,
                        dottedOverlay: "none",
                        disableProgressBar: 'on',
                        navigation: {
                            onHoverStop: "on",
                            keyboardNavigation: "on",
                            keyboard_direction: "horizontal",
                            mouseScrollNavigation: "off",
                            bullets: {
                                enable: true,
                                style: 'ares',
                                tmp: '',
                                direction: 'horizontal',
                                rtl: false,
                                container: 'slider',
                                h_align: 'right',
                                v_align: 'bottom',
                                h_offset: 200,
                                v_offset: 92,
                                space: 16,
                                hide_onleave: false,
                                hide_onmobile: false,
                                hide_under: 0,
                                hide_over: 9999,
                                hide_delay: 200,
                                hide_delay_mobile: 1200
                            },
                            arrows: {
                                enable: true,
                                style: 'uranus',
                                tmp: '',
                                rtl: $('body').attr('dir') === 'rtl' ? true : false,
                                hide_onleave: false,
                                hide_onmobile: true,
                                hide_under: 0,
                                hide_over: 9999,
                                hide_delay: 200,
                                hide_delay_mobile: 1200,
                                left: {
                                    container: 'slider',
                                    h_align: 'right',
                                    v_align: 'bottom',
                                    h_offset: 130,
                                    v_offset: 70
                                },
                                right: {
                                    container: 'slider',
                                    h_align: 'right',
                                    v_align: 'bottom',
                                    h_offset: 76,
                                    v_offset: 70
                                }
                            },
                            touch: {
                                touchenabled: "on",
                                swipe_threshold: 75,
                                swipe_min_touches: 1,
                                swipe_direction: "horizontal",
                                drag_block_vertical: false
                            }
                        },
                        viewPort: {
                            enable: true,
                            outof: "pause",
                            visible_area: "80%",
                            presize: false
                        },
                        lazyType: "smart",
                        parallax: {
                            type: "mouse",
                            origo: "slidercenter",
                            speed: 2000,
                            levels: [2, 3, 4, 5, 6, 7, 12, 16, 10, 50, 46, 47, 48, 49, 50, 55],
                            disable_onmobile: 'on'
                        }
                    };

                if(revolution_params && typeof revolution_params === 'object') {
                    revolution_obj = $.extend(true, {}, revolution_obj, revolution_params);
                }

                var revolution_obj_bp = [
                    {
                        bp: [769, 1024],
                        navigation : $.extend(true, {}, revolution_obj.navigation , {
                            bullets: {
                                direction: 'horizontal',
                                h_align: 'center',
                                v_align: 'bottom',
                                h_offset: 0,
                                v_offset: 92
                            },
                            arrows: {
                                enable: false
                            }
                        }),
                        parallax: {}
                    },
                    {
                        bp: [0, 768],
                        navigation : $.extend(true, {}, revolution_obj.navigation , {
                            bullets: {
                                direction: 'horizontal',
                                h_align: 'center',
                                v_align: 'bottom',
                                h_offset: 0,
                                v_offset: 38
                            },
                            arrows: {
                                enable: false
                            }
                        }),
                        parallax: {}
                    }
                ];

                Mogo.revolutionSlider.resizeRev({
                        slider: '.tt-sr',
                        breakpoints: [767, 1024],
                        functions: [

                        ]
                    },
                    revolution_obj,
                    revolution_obj_bp
                );

                $slider.on('click', '.tp-revslider-slidesli[data-tt-link]', function() {
                    window.location.href = $(this).attr('data-tt-link');
                });
            };
        },
        destroy: function() {
            Mogo.revolutionSlider.revapi.revkill();
        }
    }
};

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.countdown = function Countdown(selector) {
    var $countdown = $(selector ? selector : '.tt-countdown').not('.tt-countdown--init');
    
    $countdown.each(function () {
        var $this = $(this),
            date = $this.data('date'),
            zone = $this.data('zone'),
            reduction = $this.data('reduction') || false,
            hideZero = $this.data('hidezero') || true,
            set_year = $this.data('year') || 'Yrs',
            set_month = $this.data('month') || 'Mth',
            set_week = $this.data('week') || 'Wk',
            set_day = $this.data('day') || 'Day',
            set_hour = $this.data('hour') || 'Hrs',
            set_minute = $this.data('minute') || 'Min',
            set_second = $this.data('second') || 'Sec';

        if (!date) {
            return;
        } else if(zone) {
            date = moment.tz(date, zone).format();
        }

        //remove timezone
        var remove_from = date.indexOf(' +');

        if(remove_from != -1) {
            date = date.slice(0, remove_from);
        }
        //END:remove timezone

        var date_obj = new Date(date.replace(/-/g, "/"));

        if(date_obj.getTime() - new Date().getTime() <= 0) return;

        var t = $this.countdown(date_obj, function (e) {
            var format = '<span class="countdown-row">',
                structure = [
                    ['months', set_month],
                    ['daysToMonth', set_day],
                    ['hours', set_hour],
                    ['minutes', set_minute],
                    ['seconds', set_second]
                ];

            for(var i = 0; i < structure.length; i++) {
                var prop = structure[i][0],
                    time = e.offset[prop],
                    postfix = structure[i][1];

                if (i === 0 && time === 0 && hideZero === true) {
                    continue;
                }

                if(reduction && e.offset.months > 0 && (prop === 'hours' || prop === 'minutes' || prop === 'seconds')) {
                    format += '<span class="countdown-section countdown-section--small">' +
                            '<span class="countdown-amount">' + time + '</span>' +
                            '</span>';
                } else {
                    format += '<span class="countdown-section">' +
                        '<span class="countdown-amount">' + time + '</span>' +
                        '<span class="countdown-period">' + postfix + '</span>' +
                        '</span>';
                }
            }

            format += '</span>';

            $(this).html(format);
        });

        $this.addClass('.tt-countdown--init');
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.productScroll = function(update) {
    if(update) {
        var $elems = $('.tt-product__content').not('.ps');

        $elems.perfectScrollbar();

        setTimeout(function() {
            $elems.perfectScrollbar('update');
        }, 100);
    } else {
        $(window).on('load', function() {
            setTimeout(function() {
                $('.tt-product__content').perfectScrollbar();
            }, 1000);
        });
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.sidebarMobile = function() {
    var _self = this,
        $sidebar = $('.tt-sidebar'),
        $sidebar_content = $sidebar.find('.tt-sidebar__content'),
        $bg = $('.tt-sidebar__bg'),
        $btn = $('.tt-sidebar__btn'),
        $body = $('body'),
        scrollW,
        breakpoint = 1024;

    var $scrlBl = $('<div>').css({
        overflowY: 'scroll',
        width: '50px',
        height: '50px',
        visibility: 'hidden'
    });

    $body.append($scrlBl);
    scrollW = $scrlBl[0].offsetWidth - $scrlBl[0].clientWidth;
    $scrlBl.remove();

    function close(is_fast) {
        $sidebar.removeClass('tt-sidebar--open');
        $bg.removeClass('tt-sidebar__bg--visible');

        $sidebar.unbind('transitionend').one('transitionend', function () {
            $body.removeClass('ttg-ovf-hidden').removeAttr('style');
            $('.tt-header__sticky .tt-header__sidebar').removeAttr('style');

            $sidebar.removeClass('tt-sidebar--ready').removeAttr('style');
            $bg.removeClass('tt-sidebar__bg--ready');

            $sidebar_content.perfectScrollbar('destroy').removeClass('ps');
        });

        if(is_fast) $sidebar.trigger('transitionend');

        $(window).unbind('resize.sidebar');
    };

    $btn.on('click', function () {
        if(!$sidebar.hasClass('tt-sidebar--open')) {
            _self.vars.$settings_btn.trigger('togglelist.close');
            _self.vars.$user_btn.trigger('togglelist.close');
            _self.vars.$cart_btn.trigger('togglelist.close');
            _self.vars.$search_close_btn.trigger('search.close');
            _self.vars.$tonyMenu_top.TonyM('hideTM', false, false, true);

            $body.addClass('ttg-ovf-hidden').css({ 'padding-right': scrollW });
            $('.tt-header__sticky .tt-header__sidebar').css({ 'padding-right': scrollW });

            $sidebar_content.perfectScrollbar();

            $sidebar.addClass('tt-sidebar--ready');
            $bg.addClass('tt-sidebar__bg--ready');

            setTimeout(function () {
                $sidebar.addClass('tt-sidebar--open');
                $bg.addClass('tt-sidebar__bg--visible');
            }, 0);

            $(window).on('resize.sidebar', function() {
                if(window.innerWidth > breakpoint) close(true);
            });
        } else {
            close();
        }
    });

    $bg.on('click', function () {
        $sidebar.filter('.tt-sidebar--open').find($btn).trigger('click');
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.stickyBlock = {
    section: {
        init: function(options, $sticky_block) {
            if(Mogo.ie) return;
            
            var $sticky_block = $sticky_block || $('.tt-sticky-block'),
                breakpoint = 1024;

            $sticky_block.each(function() {
                var $sticky = $(this),
                    $sticky_parent = $sticky.parents('.tt-sticky-block__parent'),
                    $sticky_inner = $sticky.find('.tt-sticky-block__inner');

                function process() {
                    var wind_w = window.innerWidth,
                        top_spacing = Mogo.stickyHeader.section.$sticky ? Mogo.stickyHeader.section.$sticky.stickyHeader('getStickyHeight') : 0;

                    if(wind_w > breakpoint) {
                        if(!$sticky.hasClass('initialize')) {
                            $sticky.stickySidebar($.extend({
                                containerSelector: $sticky_parent,
                                innerWrapperSelector: $sticky_inner,
                                topSpacing: top_spacing
                            }, options));

                            $sticky.addClass('initialize');
                        } else if(!$sticky.hasClass('active')) {
                            $sticky.stickySidebar('updateSticky');
                        }

                        $sticky.addClass('active');
                    } else {
                        if($sticky.hasClass('initialize active')) {
                            //$sticky.stickySidebar('destroy');

                            $sticky.removeClass('active');
                            $sticky.removeAttr('style');

                            $sticky_inner.removeAttr('style');
                        }
                    }
                };

                $(window).on('resize.sticky-process', function() {
                    process();
                });

                $sticky.on('sticky-process', function() {
                    process();
                });
            });

            $(window).on('load', function() {
                var wind_w = window.innerWidth;

                if(wind_w > breakpoint) {
                    setTimeout(function() {
                        $sticky_block.stickySidebar('updateSticky');
                    }, 500);
                }
            });

            $sticky_block.trigger('sticky-process');
        },
        destroy: function() {
            $(window).unbind('resize.sticky-process');
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.newsletter = {
    section: {
        init: function() {
            var _self = this,
                $newsletters = $('.tt-newsletter');

            if($newsletters.length) {
                $newsletters.each(function () {
                    var $newsletter = $(this),
                        $btn_news = $newsletter.find('button'),
                        $input_news = $newsletter.find('input'),
                        transition = 700,
                        is_act = false;

                    _self.$btn_news = $btn_news;

                    function isEmail(email) {
                        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                        return regex.test(email);
                    };

                    function act(e) {
                        is_act = true;

                        var email = $input_news.prop('value'),
                            $error_text = $newsletter.find('.tt-newsletter__text-error'),
                            $default_text = $newsletter.find('.tt-newsletter__text-default');

                        if (!isEmail(email)) {
                            $btn_news.animate({ 'width': $btn_news.innerWidth() });

                            $default_text.fadeOut({
                                duration: transition / 2,
                                complete: function () {
                                    $newsletter.addClass('tt-newsletter__message tt-newsletter__error');
                                    setTimeout(function () {
                                        $btn_news.removeAttr('style');
                                        $error_text.fadeIn({
                                            duration: transition,
                                            complete: function () {
                                                setTimeout(function () {
                                                    $error_text.fadeOut({
                                                        duration: transition / 2,
                                                        complete: function () {
                                                            $newsletter.removeClass('tt-newsletter__message tt-newsletter__error');

                                                            $default_text.fadeIn({
                                                                complete: function () {
                                                                    is_act = false;
                                                                }
                                                            });
                                                        }
                                                    });
                                                }, 2000);
                                            }
                                        });
                                    }, transition);
                                }
                            });

                            e.preventDefault();
                            return false;
                        }
                    }

                    $btn_news.on('click.act', function (e) {
                        if (!is_act) {
                            return act(e);
                        }
                    });
                });
            }
        },
        destroy: function() {
            this.$btn_news.off();
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.btnToTop = {
    section: {
        init: function() {
            var $btn = $('.tt-footer__to-top'),
                bp = $btn.data('btn-top-limit') || 1000,
                is_animate = false,
                unbind = true;

            this.$btn = $btn;

            $(window).on('scroll.btntop resize.btntop', function () {
                var scroll_t = pageYOffset || Math.max($('body').scrollTop(), $('html').scrollTop());

                if(!$btn.attr('data-bind')) {
                    $btn[scroll_t > bp ? 'addClass' : 'removeClass']('show');
                }

                if(scroll_t > bp && unbind) {
                    $btn.removeAttr('data-bind');
                }
            });

            $btn.on('click', function(e) {
                if(!is_animate) {
                    is_animate = true;

                    var bind = $btn.attr('data-bind');

                    if(bind) {
                        $('html, body').velocity('stop').velocity( 'scroll' , {
                            offset: bind,
                            duration: 1000,
                            complete: function () {
                                $btn.removeAttr('data-bind');

                                is_animate = false;
                            }
                        });
                    } else {
                        var scroll_t = pageYOffset || Math.max($('body').scrollTop(), $('html').scrollTop());

                        unbind = false;

                        $btn.attr('data-bind', scroll_t);

                        $('html, body').velocity('stop').velocity( 'scroll' , {
                            offset: 0,
                            duration: 1000,
                            complete: function () {
                                is_animate = false;
                                unbind = true;
                            }
                        });
                    }
                }

                e.preventDefault();
                e.stopPropagation();
                return false;
            });
        },
        destroy: function() {
            $(window).unbind('scroll.btntop resize.btntop');
            this.$btn.off();
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.carouselBrands = {
    section: {
    	init: function () {
			var $carousel_brands = $('.tt-carousel-brands');

			$carousel_brands.slick({
				dots: false,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 2500,
				infinite: true,
				slidesToShow: 8,
				touchMove: false,
				rtl: $('body').attr('dir') === 'rtl' ? true : false,
				responsive: [
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 6
						},
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 4
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3
						},
					},
					{
						breakpoint: 479,
						settings: {
							slidesToShow: 2
						},
					},
				]
			});
		},
		destroy: function() {

		}
	}
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.carouselBox = {
    section: {
        init: function ($container) {
            var $carousel_box = $container.hasClass('tt-carousel-box') ? $container : $container.find('.tt-carousel-box'),
                speed = $carousel_box.attr('data-speed') || 2000;

            function getRand(min, max) {
                return Math.random() * (max - min) + min;
            };

            $carousel_box.each(function () {
                var $this_carousel = $(this),
                    $this_slider = $this_carousel.find('.tt-carousel-box__slider'),
                    $arrows = $this_carousel.parents('.tt-page__section').find('.tt-page__arrows'),
                    grid = $this_slider.attr('data-grid'),
                    slick_obj = {
                        dots: false,
                        arrows: false,
                        autoplay: true,
                        autoplaySpeed: speed,
                        touchMove: false
                    };

                if(!grid) grid = 4;

                if(!$this_carousel.hasClass('tt-carousel-box--vertical')) {
                    $.extend(slick_obj, {
                        rtl: $('body').attr('dir') === 'rtl' ? true : false,
                        infinite: true,
                        slidesToShow: grid,
                        responsive: [
                            {
                                breakpoint: 1400,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 1,
                                    touchMove: false
                                }
                            }
                        ]
                    });
                } else {
                    $.extend(slick_obj, {
                        infinite: false,
                        vertical: true,
                        slidesToShow: 2,
                        verticalSwiping: true,
                        responsive: [
                            {
                                breakpoint: 1025,
                                settings: {
                                    swipe: false
                                }
                            }
                        ]
                    });
                }

                $this_slider.slick(slick_obj);

                if($arrows.length) {
                    $arrows.on('click', 'span', function (e) {
                        var $this = $(this);

                        if ($this.hasClass('tt-page__arrows-prev')) {
                            $this_slider.slick('slickPrev');
                        } else if ($this.hasClass('tt-page__arrows-next')) {
                            $this_slider.slick('slickNext');
                        }
                    });
                }
            });
        },
        destroy: function() {

        }
    },
    init: function() {
        var $carousel_box = $('.tt-carousel-box').not('.tt-carousel-box--section');

        if($carousel_box.length) {
            this.section.init($carousel_box);
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.sliderBlog = function() {
    var $slider_blog = $('.tt-post__slider');

    $slider_blog.each(function () {
        var $this = $(this),
            $post = $this.parents('.tt-post'),
            $slider_nav = $('<div>').appendTo($post.find('.tt-post__slider-nav'));

        $this.slick({
            rtl: $('body').attr('dir') === 'rtl' ? true : false,
            arrows: true,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 2500,
            fade: true,
            prevArrow: '<i class="icon-left-open-big"></i>',
            nextArrow: '<i class="icon-right-open-big"></i>',
            appendDots: $slider_nav,
            appendArrows: $slider_nav,
        });
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.sliderBlogGrid = function() {
    var $slider_blog_grid = $('.tt-post-grid__slider');

    $slider_blog_grid.each(function () {
        var $this = $(this),
            $post = $this.parents('.tt-post-grid'),
            $slider_nav = $post.find('.tt-post-grid__slider-nav');

        $this.slick({
            rtl: $('body').attr('dir') === 'rtl' ? true : false,
            arrows: true,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 2500,
            fade: true,
            prevArrow: '<i class="icon-left-open-big"></i>',
            nextArrow: '<i class="icon-right-open-big"></i>',
            appendDots: $slider_nav,
            appendArrows: $slider_nav,
        });
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.sliderBlogSingle = function() {
    var $post_slider = $('.tt-post-slider');

    $post_slider.slick({
        rtl: $('body').attr('dir') === 'rtl' ? true : false,
        arrows: true,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 2500,
        prevArrow: '<i class="slick-prev icon-left-open-big"></i>',
        nextArrow: '<i class="slick-next icon-right-open-big"></i>',
    }).addClass('tt-post-slider__init').hide().fadeIn();
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.scrollSlider = {
    section: {
        firstLoad: true,
        init: function() {
            var _self = this;

            $.fn.sliderScroll = function() {
                var $slider = this;

                if (!$slider.length) return false;

                var $nav = $slider.find('.tt-slider-scroll__nav'),
                    $nav_ul = $nav.find('ul'),
                    $nav_arrows = $nav.find('.tt-slider-scroll__nav_arrows span'),
                    scroll_is_act = false;

                _self.bullets = $nav_ul;
                _self.arrows = $nav_arrows;

                $nav_ul.on('click', 'li', function(e) {
                    if(!scroll_is_act) {
                        scroll_is_act = true;

                        var wind_H = window.innerHeight,
                            $li = $nav_ul.children(),
                            $item,
                            item_top,
                            item_H,
                            scroll_to,
                            eq = 0,
                            i = 0;

                        for (; i < $li.length; i++) {
                            if ($li.get(i) === this)
                                eq = i;
                        }

                        $item = $slider.find('.tt-slider-scroll__item').eq(eq),
                            item_top = $item.offset().top,
                            item_H = $item.outerHeight(),
                            scroll_to = item_top - wind_H / 2 + item_H / 2;

                        $('html, body').animate({
                            scrollTop: scroll_to
                        }, {
                            duration: 500,
                            complete: function () {
                                scroll_is_act = false;
                            }
                        });
                    }

                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                });

                $nav_arrows.on('click', function (e) {
                    var index = $nav_arrows.index(this),
                        $nav_li_act = $nav.find('li.active');

                    if(index === 0) {
                        $nav_li_act.prev().trigger('click');
                    } else if (index === 1) {
                        $nav_li_act.next().trigger('click');
                    }
                });

                function moveAction() {
                    var wind_H = window.innerHeight,
                        wind_W = window.innerWidth,
                        $items = $slider.find('.tt-slider-scroll__item');

                    $items.height(wind_H);

                    var nav_H = $nav.innerHeight(),
                        nav_top = $nav_ul.offset().top,
                        $last_item = $slider.find('.tt-slider-scroll__item:last-child'),
                        last_item_top = $last_item.offset().top,
                        last_item_H = $last_item.outerHeight(),
                        last_item_max = last_item_top + last_item_H / 2,
                        $first_item = $slider.find('.tt-slider-scroll__item').eq(0),
                        first_item_top = $first_item.offset().top,
                        first_item_H = $first_item.outerHeight(),
                        first_item_max = first_item_top + first_item_H / 2,
                        pos_top = 0,
                        i = 0;

                    if (last_item_max < pageYOffset + wind_H / 2){
                        pos_top = last_item_max - nav_H / 2 - pageYOffset;
                    } else if (first_item_max > pageYOffset + wind_H / 2) {
                        pos_top = first_item_max - nav_H / 2 - pageYOffset;
                    } else {
                        pos_top = wind_H / 2 - nav_H / 2;
                    }

                    $nav.css({
                        'top': pos_top
                    });

                    for(; i < $items.length; i++) {
                        var $item = $items.eq(i),
                            this_bottom = $item.offset().top + $item.outerHeight();

                        if (this_bottom > nav_top + nav_H / 2) {
                            $nav_ul.find('li').removeClass('active').eq(i).addClass('active');
                            break;
                        }
                    }
                };

                $(window).on('resize.scrollslider scroll.scrollslider load.scrollslider ', function() {
                    moveAction();
                });

                if(this.firstLoad) {
                    this.firstLoad = false;
                } else {
                    moveAction();
                }

                $slider.velocity({ opacity: 1 }, 1000);
            };

            $('.tt-slider-scroll').sliderScroll();
        },
        destroy: function() {
            $(this.arrows, this.bullets).off();
            $(window).unbind('resize.scrollslider scroll.scrollslider load.scrollslider');
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.tabs = function() {
    $.fn.ttTabs = function (options) {
        function ttTabs(tabs) {
            var $tabs = $(tabs),
                trl = $('body').attr('dir') === 'rtl' ? true : false,
                tabs_type = $tabs.attr('data-tt-type'),
                $head = $tabs.find('.tt-tabs__head'),
                $head_slider = $head.find('.tt-tabs__slider'),
                $head_btn = $head_slider.find('.tt-tabs__btn'),
                $border = $head.find('.tt-tabs__border'),
                $body = $tabs.find('.tt-tabs__body'),
                $body_tab = $body.find('> div'),
                anim_tab_duration = options.anim_tab_duration || 500,
                anim_scroll_duration = options.anim_scroll_duration || 500,
                breakpoint = 1024,
                scrollToOpenMobile = (options.scrollToOpenMobile !== undefined) ? options.scrollToOpenMobile : true,
                singleOpen = (options.singleOpen !== undefined) ? options.singleOpen : true,
                toggleOnDesktop = (options.toggleOnDesktop !== undefined) ? options.toggleOnDesktop : true,
                effect = (options.effect !== undefined) ? options.effect : 'slide',
                offsetTop = (options.offsetTop !== undefined) ? options.offsetTop : '',
                goToTab = options.goToTab,
                $btn_prev = $head.find('.tt-tabs__btn-prev'),
                $btn_next = $head.find('.tt-tabs__btn-next');

            function _closeTab($li, desktop) {
                var $animElem,
                    anim_obj = {
                        duration: anim_tab_duration,
                        complete: function () {
                            $(this).removeAttr('style');
                        }
                    };

                function _anim_func($animElem) {
                    switch(effect) {
                        case 'toggle':
                            $animElem.hide().removeAttr('style');
                            break;
                        case 'slide':
                            $animElem.velocity('slideUp', anim_obj);
                            break;
                        default:
                            $animElem.velocity('slideUp', anim_obj);
                    }
                };

                if(desktop || singleOpen) {
                    $head_btn.removeClass('active');
                    $animElem = $body_tab.filter('.active').removeClass('active').find('> div').stop();

                    _anim_func($animElem);
                } else {
                    var index = $head_btn.index($li);

                    $li.removeClass('active');
                    $animElem = $body_tab.eq(index).removeClass('active').find('> div').stop();

                    _anim_func($animElem);
                }
            };

            function _openTab($li, desktop, beforeOpen, afterOpen, trigger) {
                var index = $head_btn.index($li),
                    $body_li_act = $body_tab.eq(index),
                    $animElem,
                    $sticky = $('.tt-product-head__sticky.tt-sticky-block.initialize'),
                    anim_obj = {
                        duration: anim_tab_duration,
                        complete: function () {
                            if($sticky.length) {
                                $sticky.stickySidebar('updateSticky');
                            }

                            if(afterOpen) {
                                afterOpen($body_li_act);
                            }
                        }
                    };

                function _anim_func($animElem) {
                    if($head_slider.hasClass('slick-initialized')) {
                        var btn_l = $li.last().get(0).getBoundingClientRect().left,
                            btn_r = $li.last().get(0).getBoundingClientRect().right,
                            head_l = $head.get(0).getBoundingClientRect().left,
                            head_r = $head.get(0).getBoundingClientRect().right;

                        if(btn_r > head_r) $head_slider.slick('slickNext');
                        else if(btn_l < head_l) $head_slider.slick('slickPrev');
                    }

                    if(beforeOpen) {
                        beforeOpen($li.find('> span'));
                    }

                    $sticky.height('auto');

                    switch(effect) {
                        case 'toggle':
                            $animElem.show();
                            if(afterOpen) afterOpen($body_li_act);
                            break;
                        case 'slide':
                            $animElem.velocity( 'slideDown', anim_obj);
                            break;
                        default:
                            $animElem.velocity( 'slideDown', anim_obj);
                    }

                    /*if(effect === 'toggle') {
                     $animElem.show();
                     if(afterOpen) afterOpen($body_li_act);
                     } else if(effect === 'slide') {
                     $animElem.slideDown(anim_obj);
                     } else {
                     $animElem.slideDown(anim_obj);
                     }*/
                };

                $li.addClass('active');
                $animElem = $body_li_act.addClass('active').find('> div').stop();

                _anim_func($animElem);
            };

            function _replaceBorder($this, animate) {
                var $btns_body = ($head_slider.hasClass('slick-initialized')) ? $head_slider.find('.slick-track') : $head;

                if(tabs_type === 'horizontal') {
                    var position = {},
                        side = trl ? 'right' : 'left';

                    if($this.length) {
                        var span_l = $this.get(0).getBoundingClientRect()[side],
                            head_l = $btns_body.get(0).getBoundingClientRect()[side],
                            left = span_l - head_l;

                        if(trl) left *= -1;

                        position['width'] = $this.innerWidth();
                        position[side] = left;
                    } else {
                        position['width'] = 0;
                        position[side] = 0;
                    }

                } else if(tabs_type === 'vertical') {
                    if($this.length) {
                        var span_t = $this.get(0).getBoundingClientRect().top,
                            head_t = $head.get(0).getBoundingClientRect().top,
                            position = {
                                top: span_t - head_t,
                                height: $this.innerHeight()
                            };
                    } else {
                        var position = {
                            top: 0,
                            height: 0
                        };
                    }
                }

                if(animate) $border.velocity('stop').velocity(position, anim_tab_duration);
                else $border.velocity('stop').css(position);
            };

            $head_btn.on('click', '> span', function (e, trigger) {
                var $this = $(this),
                    $li = $this.parent(),
                    wind_w = window.innerWidth,
                    desktop = wind_w > breakpoint,
                    trigger = (trigger === 'trigger') ? true : false;

                if($li.hasClass('active')) {
                    if(desktop && !toggleOnDesktop) return;

                    _closeTab($li, desktop);

                    _replaceBorder('', true);
                } else {
                    _closeTab($li, desktop);

                    _openTab($li, desktop,
                        function($li_act) {
                            if(desktop) {
                                var animate = !trigger;

                                _replaceBorder($li_act, animate);
                            }
                        },
                        function ($body_li_act) {
                            if(!desktop && !trigger && scrollToOpenMobile) {
                                var tob_t = $body_li_act.offset().top;
                                $('html, body').velocity('stop').velocity( 'scroll' , {
                                    offset: tob_t,
                                    duration: anim_scroll_duration
                                });
                            }
                        }
                    );
                }
            });

            $body.on('click', '> div > span', function (e) {
                var $this = $(this),
                    $li = $this.parent(),
                    index = $body_tab.index($li);

                $head_btn.eq(index).find('> span').trigger('click');
            });

            function _toTab(tab, scrollTo, focus) {
                var wind_w = window.innerWidth,
                    desktop = wind_w > breakpoint,
                    header_h = 0,
                    $sticky = $(offsetTop),
                    $openTab = $head_btn.filter('[data-tab="' + tab + '"]'),
                    $scrollTo = $(scrollTo);

                if(desktop && $sticky.length) {
                    header_h = $sticky.height();
                }

                function srlToBlock() {
                    if ($scrollTo.length) {
                        $('html, body').velocity( 'scroll' , {
                            offset: $scrollTo.offset().top - header_h,
                            duration: anim_scroll_duration,
                            complete: function () {
                                var $focus = $(focus);

                                if ($focus.length) $focus.focus();
                            }
                        });
                    }
                };

                if(!$openTab.hasClass('active')) {
                    $('html, body').velocity('stop').velocity( 'scroll' , {
                        offset: $tabs.offset().top - header_h,
                        duration: anim_scroll_duration,
                        complete: function () {
                            _closeTab($openTab, desktop);

                            _openTab($openTab, desktop,
                                function($li_act) {
                                    _replaceBorder($li_act, true);
                                },
                                function () {
                                    srlToBlock();
                                }
                            );
                        }
                    });
                } else {
                    srlToBlock();
                }
            };

            if($.isArray(goToTab) && goToTab.length) {
                $(goToTab).each(function () {
                    var elem = this.elem,
                        tab = this.tab,
                        scrollTo = this.scrollTo,
                        focus = this.focus;

                    $(elem).on('click', function (e) {
                        _toTab(tab, scrollTo, focus);

                        e.preventDefault();
                        return false;
                    });
                });
            }

            function _btn_disabled(currentSlide) {
                var btn_last_r = $head_btn.last().get(0).getBoundingClientRect().right,
                    head_r = $head.get(0).getBoundingClientRect().right;

                if(currentSlide === 0) $btn_prev.addClass('disabled');
                else $btn_prev.removeClass('disabled');

                if(btn_last_r <= head_r) $btn_next.addClass('disabled');
                else $btn_next.removeClass('disabled');
            };

            function _slider_init() {
                if($head_slider.hasClass('slick-initialized')) return;

                $head.addClass('tt-tabs__head--slider');

                $head_slider.slick({
                    infinite: false,
                    slidesToShow: 1,
                    variableWidth: true,
                    draggable: false,
                    dots: false,
                    arrows: false
                });

                $head_slider.find('.slick-track').append($border);

                $btn_prev.addClass('disabled');

                $head_slider.on('afterChange', function(e, slick, currentSlide) {
                    _btn_disabled(currentSlide);
                });

                $btn_prev.on('click', function() {
                    if($(this).hasClass('disabled')) return;
                    $head_slider.slick('slickPrev');
                });

                $btn_next.on('click', function() {
                    if($(this).hasClass('disabled')) return;
                    $head_slider.slick('slickNext');
                });
            };

            function _slider_destroy() {
                if(!$head_slider.hasClass('slick-initialized')) return;

                $($head_slider, $btn_prev, $btn_next).off();

                $head.append($border);

                $head_slider.slick('unslick');

                $head.removeClass('tt-tabs__head--slider');
            };

            $(window).on('resize', function () {
                var wind_w = window.innerWidth,
                    desktop = wind_w > breakpoint,
                    head_w = $head.innerWidth(),
                    li_w = 0;

                $head_btn.each(function () {
                    li_w += $(this).innerWidth();
                });

                if(desktop) {
                    var $li_act = $head_btn.filter('.active'),
                        $span_act = $li_act.find('> span');

                    if(!singleOpen && $span_act.length > 1) {
                        var $save_active = $li_act.first();

                        _closeTab('', desktop);
                        _openTab($save_active, desktop);
                    }

                    if(li_w > head_w) {
                        if(tabs_type === 'horizontal') _slider_init();
                        if($head_slider.hasClass('slick-initialized')) {
                            setTimeout(function() {
                                _btn_disabled($head_btn.index($('.tt-tabs__btn.slick-current')));
                            }, 0);
                        }
                        _replaceBorder($span_act, false);
                    } else {
                        if(tabs_type === 'horizontal') _slider_destroy();
                        _replaceBorder($span_act, false);
                    }
                } else {
                    if(tabs_type === 'horizontal') _slider_destroy();
                    $border.removeAttr('style');
                }
            });

            $head_btn.filter('[data-active="true"]').find('> span').trigger('click', ['trigger']);

            return $tabs;
        };

        $(this).each(function() {
            new ttTabs(this);
        });
    };

    var tabsObj = {
        singleOpen: true,
        anim_tab_duration: 500,
        anim_scroll_duration: 500,
        toggleOnDesktop: true,
        scrollToOpenMobile: true,
        effect: 'slide',
        offsetTop: '.tt-header[data-sticky="true"]'
    };

    $('.tt-product-page__tabs').ttTabs($.extend(tabsObj, {
        goToTab: [
            {
                elem: '.tt-product-head__review-add > a',
                tab: 'review-shopify',
                scrollTo: '.tt-tabs-product__review.tt-review-shopify'
            },
        ]
    }));

    $('.tt-my-account__tabs').ttTabs(tabsObj);
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.setStars = function() {
    var stars_input = '.tt-stars.tt-stars__input';

    function get_stars(e) {
        var $this = $(this),
            $set = $this.find('.tt-stars__set'),
            $input = $this.find('input'),
            stars_w = $this.width(),
            pos_x = (e.pageX - $this.offset().left),
            set_stars;

        if(pos_x < 0) pos_x = 0;

        set_stars = (Math.floor(5 * (pos_x / stars_w)) + 1) * 20;

        $set.css({ width: set_stars * 20 + '%'});

        $set.css({ width: set_stars + '%'});

        return set_stars;
    };

    $(document).on({
        mousemove: function (e) {
            get_stars.call(this, e);
        },
        mouseleave: function () {
            var $this = $(this),
                $set = $this.find('.tt-stars__set'),
                $input = $this.find('input'),
                value = $input.val();

            if(value.length) {
                $set.css({ width: value + '%'});
            }
        },
        click: function (e) {
            var $input = $(this).find('input');

            $input.val(get_stars.call(this, e));

        }
    }, stars_input);
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.socialIcons = function() {
    var $iconsAddThis = $('<script type="text/javascript" src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-58cfdc36dacf870d"></script>'),
        i = 0;

    if($('.addthis_toolbox').length) {
        $('body').append($iconsAddThis);

        function removeLabels() {
            setTimeout(function () {
                var labels = $('.at-resp-share-element');

                if(labels.length) {
                    labels.find('.at-label').remove();
                } else if(i < 50) {
                    removeLabels();
                }

                i++;
            }, 10);
        };

        removeLabels();
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.instafeed = {
    section: {
        init: function ($container) {
            var _ = this,
                $instagram = $container.find('#instafeed');

            if($instagram.length) {
                $.fn.func_instafeed = function(new_obj) {
                    var $this = $(this);

                    if (!$this.length) return;

                    var new_obj = new_obj || {},
                        set_obj = {
                            get: 'user',
                            userId: window.themeinstagram.userid,
                            clientId: window.themeinstagram.clientid,
                            accessToken: window.themeinstagram.token,
                            limit: 10,
                            sortBy: 'most-liked',
                            resolution: "standard_resolution",
                            template: '<div class="col-xl-12"><a href="{{link}}" class="tt-instagram"><img src="{{image}}" alt="Image name"><div class="tt-instagram__mask"><i class="icon-instagram-1"></i></div></a></div>',
                        };

                    $.extend(set_obj, new_obj);

                    var feed = new Instafeed(set_obj);
                    feed.run();
                };

                $instagram.func_instafeed({
                    after: function() {
                        $instagram.slick({
                            dots: false,
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 2000,
                            infinite: true,
                            slidesToShow: 6,
                            touchMove: false,
                            rtl: $('body').attr('dir') === 'rtl' ? true : false,
                            responsive: [
                                {
                                    breakpoint: 1400,
                                    settings: {
                                        slidesToShow: 4
                                    }
                                },
                                {
                                    breakpoint: 769,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                }
                            ]
                        });

                        _.$instagram = $instagram;
                    }
                });
            }
        },
        destroy: function() {
            if(this.$instagram && this.$instagram.hasClass('slick-initialized')) {
                this.$instagram.slick('destroy');
                this.$instagram = null;
            }
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.gallery = function() {
    var $album = $('.tt-gallery .tt-promobox');

    function _show_popup($slider_clone, current_slide) {
        var galleryTop, galleryThumbs;

        $.magnificPopup.open({
            mainClass: 'mfp-with-zoom mfp-gallery',
            removalDelay: 300,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close icon-cancel-circled2"></button>',
            items: [
                {
                    src: $slider_clone,
                    type: 'inline'
                }
            ],
            callbacks: {
                open: function () {
                    var $gallery_top = $('.mfp-content .gallery-top');

                    $(window).on('resize.gallery gallery', function() {
                        $gallery_top.css({ 'max-height': window.innerHeight - 160 + 'px' });
                    });

                    $(window).trigger('gallery');

                    galleryTop = new Swiper('.mfp-content .gallery-top', {
                        nextButton: '.swiper-btn-next',
                        prevButton: '.swiper-btn-prev',
                        initialSlide: current_slide
                    });

                    galleryThumbs = new Swiper('.mfp-content .gallery-thumbs', {
                        centeredSlides: true,
                        slidesPerView: 'auto',
                        touchRatio: 0.2,
                        slideToClickedSlide: true,
                        autoHeight: true,
                        initialSlide: current_slide
                    });


                    galleryTop.params.control = galleryThumbs;
                    galleryThumbs.params.control = galleryTop;

                    setTimeout(function() {
                        galleryThumbs.slideTo(current_slide);
                    }, 100);
                },
                afterClose: function () {
                    galleryTop.destroy();
                    galleryThumbs.destroy();
                    $slider_clone.remove();
                    $(window).unbind('resize.gallery');
                },
            }
        });
    };

    function _wrap_tags($tags, tags) {
        for(var j = 0; j < tags.length; j++) {
            var this_tag = (j < tags.length - 1) ? tags[j] + ', ' : tags[j];
            $tags.append($('<span>').html(this_tag));
        }
    };

    $album.on('click', function (e) {
        var index = $album.index(this),
            $slider_clone = $('.tt-gallery > .tt-gallery__slider').clone();

        $slider_clone.find('.gallery-top').append($('<div>').addClass('swiper-wrapper'));
        $slider_clone.find('.gallery-thumbs').append($('<div>').addClass('swiper-wrapper'));

        var $gallery_top = $slider_clone.find('.gallery-top .swiper-wrapper'),
            $gallery_thumbs = $slider_clone.find('.gallery-thumbs .swiper-wrapper');

        $album.each(function() {
            var $this = $(this),
                $image = $('<img>').attr('src', $this.attr('data-photo')).addClass('swiper-lazy'),
                $info = $('<div>').addClass('swiper-info'),
                $title = $('<div>').addClass('swiper-title').html($this.attr('data-title')),
                $tags = $('<div>').addClass('swiper-tags'),
                tags = $this.attr('data-tags').split(', ');

            _wrap_tags($tags, tags);

            $info.append($title, $tags);

            $gallery_top.append($('<div>').addClass('swiper-slide').append($info, $image));
            $gallery_thumbs.append($('<div>').addClass('swiper-slide').append($image.clone()));
        });

        _show_popup($slider_clone, index);

        e.preventDefault();
        return false;
    });

    $(document).on('mousedown', '.gallery-top .swiper-slide', function (e) {
        if($(e.target).hasClass('swiper-slide')) {
            $(this).one({
                'mouseup.clickbg': function () {
                    $('.mfp-bg').trigger('click');
                }
            });
        }
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.progressBar = function() {
    var $progress_bar = $('.tt-prog-bar'),
        duration = 2000;

    $(function() {
        $progress_bar.each(function() {
            var $this = $(this),
                val = $this.attr('data-tt-val') || false;

            if(val) {
                var $range = $this.find('.tt-prog-bar__range > div'),
                    $numb = $this.find('span');

                $range.animate({
                    width: val + '%'
                }, {
                    duration: duration,
                    step: function(num) {
                        $numb.html(Math.round(num) + '%');
                    }
                });
            }
        });
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.toggleProductParam = function() {
    var $param_control = $('.tt-summary__products_param-control'),
        param = '.tt-summary__products_param';

    $param_control.on('click', function() {
        var $this = $(this),
            $param = $this.parent().find(param);

        $this.toggleClass('active');

        if($this.hasClass('active')) {
            $param.velocity('stop').removeAttr('style').velocity('slideDown', 400);
        } else {
            $param.velocity('stop').velocity('slideUp', 400);
        }
    });

    $('.tt-summary__products_param-control--open').trigger('click');
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.dbClickLink = function() {
    var Modernizr = window.Modernizr;

    if( Modernizr.touch ){

        (function link_dbclick() {
            var link_dbclick = 'a[data-ttg-event="link-dbclick"]',
                active_link = null;

            $(document).on('click', link_dbclick, function (e) {
                if(active_link !== this) {
                    active_link = this;
                    e.preventDefault;
                    return false;
                } else {
                    active_link = null;
                }
            });
        })();
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/
 * support@tonytemplates.com
 */

Mogo.productGLR = {
    section: {
        init: function(options, $images) {
            var $images = $images || $('.tt-product-head__images');

            if($images.hasClass('prdbut__gallery') && $images.find('.tt-product-head__image-main').length) {
                $.widget( 'ui.productGallery', {
                    options: {
                        bp: 1024,
                        bp_slick: 479,
                        fotorama: {
                            nav: false,
                            arrows: false,
                            allowfullscreen: true,
                            auto: false,
                            shadows: false,
                            transition: 'slide',
                            clicktransition: 'crossfade'
                        },
                        slick: {
                            vertical: true,
                            verticalSwiping: true,
                            slidesToShow: 5,
                            slidesToScroll: 5,
                            dots: false,
                            arrows: false,
                            infinite: false,
                            responsive: [
                                {
                                    breakpoint: 1400,
                                    settings: {
                                        vertical: false,
                                        verticalSwiping: false,
                                        slidesToShow: 4,
                                        slidesToScroll: 4
                                    }
                                },
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        vertical: false,
                                        verticalSwiping: false,
                                        slidesToShow: 5,
                                        slidesToScroll: 5
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        vertical: false,
                                        verticalSwiping: false,
                                        slidesToShow: 4,
                                        slidesToScroll: 4
                                    }
                                }
                            ]
                        },
                        zoom: {
                            zoomType: "inner",
                            cursor: "crosshair",
                            easing : true,
                            zoomWindowFadeIn: 500,
                            zoomWindowFadeOut: 500
                        },
                        zoomEnable: true,
                        arrows: true,
                        btnZoom: false,
                        fullscreen: true
                    },
                    _create: function() {
                        var _self = this;

                        this.$image = this.element;
                        this.$main = this.$image.find('.tt-product-head__image-main');
                        this.$preview = this.$image.find('.tt-product-head__image-preview');
                        this.zoom_src = {};
                        this.$main_act_img = null;
                        this.slick_state = false;
                        this.zoom_activate = true;
                        this.zoom_state = false;
                        this.id = 'id' + Math.ceil(Math.random() * 10000000);
                        this.afterChange = [];
                        this.switchActTrigger = false;
                        this.index_id_obj = this.$main.data('index-id');

                        if(this.$main.data('arrows') != undefined) {
                            this.options.arrows = this.$main.data('arrows');
                        }

                        if(this.$main.data('fullscreen') != undefined) {
                            this.options.fullscreen = this.$main.data('fullscreen');
                        }

                        if(this.$main.data('zoom') != undefined) {
                            this.options.zoomEnable = this.$main.data('zoom');
                        }

                        this.options.fotorama.allowfullscreen = this.options.fullscreen;

                        this.$main.addClass('ttg-loading');

                        this.$main.find('img').each(function() {
                            var $this = $(this);

                            _self.zoom_src[$this.attr('src')] = $this.attr('data-zoom-image');
                        });

                        if(this.$main.find('img').length === 1) {
                            this.$main.addClass('tt-product-head__image-main--single');
                        }

                        this.fotorama = this.$main.fotorama(this.options.fotorama).data('fotorama');

                        if(this.options.fullscreen) {
                            this.$btn_full = $('<div>').addClass('fotorama__fullscreen-custom').append($('<i>').addClass('icon-search'));

                            this.$main.append(this.$btn_full);

                            this.$btn_full.on('click', function() {
                                var $icon = _self.$btn_full.find('i');

                                if(_self.$main.hasClass('fotorama--fullscreen')) {
                                    _self.fotorama.cancelFullScreen();

                                    _self._checkSlick();

                                    _self.$main_act_img = _self.$main.find('.fotorama__active img');

                                    _self._zoomInit();

                                    _self.$main.trigger('offfullscreen', _self.fotorama);

                                    $icon.removeClass('icon-cancel').addClass('icon-search');

                                    _self._startFuncAfterChange();
                                } else {
                                    _self._zoomDestroy();

                                    _self.fotorama.requestFullScreen();

                                    _self.$main.trigger('infullscreen', _self.fotorama);

                                    $icon.addClass('icon-cancel').removeClass('icon-search');

                                    _self._startFuncAfterChange();
                                }
                            });
                        }

                        if(this.options.btnZoom) {
                            this.$btn_zoom_toggle = $('<div>').addClass('fotorama__btn-zoom').append($('<i>').addClass('icon-zoom-in'));

                            this.$main.append(this.$btn_zoom_toggle);

                            this.$btn_zoom_toggle.on('click', function() {
                                if(_self.zoom_state) _self.zoomToggle('off');
                                else _self.zoomToggle('on');
                            });
                        }

                        if(this.options.arrows) {
                            this.$arrow_prev = $('<div>').addClass('fotorama__arrow-custom fotorama__arrow-custom--disabled fotorama__arrow-custom-prev').append($('<i>').addClass('icon-left-open-big'));
                            this.$arrow_next = $('<div>').addClass('fotorama__arrow-custom fotorama__arrow-custom--disabled fotorama__arrow-custom-next').append($('<i>').addClass('icon-right-open-big'));

                            this.$main.append(this.$arrow_prev, this.$arrow_next);

                            this.$arrow_prev.on('click', function() {
                                _self._setEffect('crossfade', function() {
                                    _self.fotorama.show('<');
                                });
                            });

                            this.$arrow_next.on('click', function() {
                                _self._setEffect('crossfade', function() {
                                    _self.fotorama.show('>');
                                });
                            });
                        }

                        //slick
                        this.$prev_slides = this.$preview.find('img, .tt-product-head__btn-video');

                        this.$preview.one('init', function() {
                            _self.slick_is_init = true;
                        });

                        this.$preview.on('mousedown', '.slick-slide', function() {
                            $(this).one({
                                'mouseup': function(e) {
                                    var $this = $(this);

                                    _self.switchImage($this);
                                }
                            });
                        });

                        this._slickInit();

                        this.$image.addClass('tt-product-head__images--loaded');

                        function fotoramaChangeEvent() {
                            _self.$main.on('fotorama:show.change', function(e, fotorama) {
                                _self.$main.unbind('fotorama:showend.change fotorama:load.change');

                                _self._zoomDestroy();

                                _self._checkBtns(fotorama);

                                _self.$main.one('fotorama:load.change', function() {
                                    _self.$main_act_img = _self.$main.find('.fotorama__active img');

                                    _self._zoomInit();
                                });

                                _self.$main.one('fotorama:showend.change', function(e, fotorama) {
                                    if(_self.$main.find('.fotorama__active img').attr('src')) {
                                        _self.$main.trigger('fotorama:load.change');
                                    }

                                    _self._checkSlick();
                                });

                                _self._startFuncAfterChange();
                                _self.switchActTrigger = false;
                            });
                        };

                        this.$main.one('fotorama:load', function(e, fotorama) {
                            _self.$main_act_img = _self.$main.find('.fotorama__active img');

                            _self._zoomInit();

                            _self._checkBtns(fotorama);

                            fotoramaChangeEvent();

                            _self.$main.removeClass('ttg-loading');

                            _self.fotorama_is_init = true;
                        });

                        $(window).on('resize.productgallery' + this.id, function() {
                            _self._debounce(function() {
                                _self._slickInit();
                                _self._zoomDestroy();
                                _self._zoomInit();
                            });
                        });

                        if(Mogo.productController.build) {
                            Mogo.productController.build.addGallery($images);
                        }
                    },
                    _slickInit: function() {
                        var this_state = window.innerWidth > this.options.bp_slick ? true : false;

                        if(this_state !== this.slick_state) {
                            if(this_state) {
                                if(this.$preview.hasClass('slick-initialized')) this.$preview.slick('setPosition');
                                else this.$preview.slick(this.options.slick);
                            } else {
                                if(this.$preview.hasClass('slick-initialized')) this.$preview.slick('destroy');
                                this.slick_is_init = true;
                            }

                            this.slick_state = this_state;
                        }
                    },
                    _checkSlick: function() {
                        if(this.$main.hasClass('fotorama--fullscreen') || !this.$preview.hasClass('slick-initialized')) return;

                        var index = this.fotorama.activeIndex,
                            image_id = this.index_id_obj[index],
                            $current_slide = this.$prev_slides.filter('[data-prdbut-image-id="' + image_id + '"]'),
                            slide_index = this.$prev_slides.index($current_slide);

                        this.$prev_slides.removeClass('current');
                        $current_slide.addClass('current');
                        this.$preview.slick('slickGoTo', slide_index);
                    },
                    _checkBtns: function(fotorama) {
                        if(this.options.arrows) {
                            var index = fotorama.activeFrame.i;

                            if(index === 1) {
                                this.$arrow_prev.addClass('fotorama__arrow-custom--disabled');
                            } else {
                                this.$arrow_prev.removeClass('fotorama__arrow-custom--disabled');
                            }

                            if(index === fotorama.size) {
                                this.$arrow_next.addClass('fotorama__arrow-custom--disabled');
                            } else {
                                this.$arrow_next.removeClass('fotorama__arrow-custom--disabled');
                            }
                        }
                    },
                    _zoomDestroy: function () {
                        if(this.options.zoomEnable && this.zoom_state && this.$zoomContainer) {
                            $.removeData(this.$main_act_img, 'elevateZoom');

                            this.$zoomContainer.remove();
                            this.$zoomContainer = null;

                            this.$main.removeClass('fotorama--zoom');

                            this.zoom_state = false;
                        }
                    },
                    _zoomInit: function () {
                        if(this.options.zoomEnable && this.$main_act_img.length && window.innerWidth > this.options.bp && this.zoom_activate && !this.$main.hasClass('fotorama--fullscreen')) {
                            var _self = this,
                                set_zoom_src = this.zoom_src[this.$main_act_img.attr('src')];

                            if(!set_zoom_src) return;

                            this.$main_act_img.attr('data-zoom-image', set_zoom_src);;

                            this.$main_act_img.elevateZoom(this.options.zoom);

                            function replaceCont() {
                                setTimeout(function() {
                                    _self.$zoomContainer = $('body > .zoomContainer');
                                    if(_self.$zoomContainer.length) {
                                        _self.$zoomContainer.appendTo(_self.$main);
                                    } else {
                                        replaceCont();
                                    }
                                }, 20);
                            };

                            replaceCont();

                            this.$main.addClass('fotorama--zoom');

                            this.zoom_state = true;
                        }
                    },
                    zoomToggle: function(state) {
                        if(this.$btn_zoom_toggle) {
                            var $icon = this.$btn_zoom_toggle.find('i');

                            $icon.removeAttr('class');

                            if(state === 'on') {
                                $icon.addClass('icon-zoom-in');

                                this.zoom_activate = true;

                                this._zoomInit();
                            } else if(state === 'off') {
                                $icon.addClass('icon-zoom-out');

                                this.zoom_activate = false;

                                this._zoomDestroy();
                            }
                        }
                    },
                    _setEffect: function(effect, func) {
                        var _self = this;

                        this.fotorama.setOptions({ transition: effect });

                        func();

                        this.$main.one('fotorama:showend', function() {
                            _self.fotorama.setOptions({ transition: 'slide' });
                        });
                    },
                    _startFuncAfterChange: function() {
                        var _self = this;

                        if(this.afterChange.length) {
                            $.each(this.afterChange, function() {
                                if(typeof this === 'function') this(_self.fotorama, _self.switchActTrigger, _self.index_id_obj);
                            });
                        }
                    },
                    addFuncAfterChange: function(func) {
                        this.afterChange.push(func);
                    },
                    switchImage: function($slide) {
                        if($slide.hasClass('current')) return;

                        var _self = this,
                            image_id = $slide.data('prdbut-image-id');

                        (function recurs_wait() {
                            if(_self.fotorama_is_init) {
                                var index = 0,
                                    i = 0;

                                for(; i < _self.index_id_obj.length; i++) {
                                    if(_self.index_id_obj[i] == image_id) index = i;
                                }

                                _self._setEffect('crossfade', function() {
                                    _self.fotorama.show(index);
                                });
                            } else {
                                _self.$main.one('fotorama:load', function() {
                                    recurs_wait();
                                });

                                _self.$preview.on('init', function() {
                                    recurs_wait();
                                });
                            }
                        })();
                    },
                    switchImageById: function(image_id) {
                        var _self = this,
                            $slide = this.$prev_slides.filter('[data-prdbut-image-id="' + image_id + '"]');

                        this.switchActTrigger = true;

                        _self.switchImage($slide);
                    },
                    _debounce: function(func) {
                        var wind_w = window.innerWidth,
                            timeout;

                        timeout = setInterval(function() {
                            var wind_w_int = window.innerWidth;
                            if (wind_w === wind_w_int) {
                                setTimeout(function() {
                                    func();
                                }, 200);
                            }
                            clearTimeout(timeout);
                        }, 100);
                    },
                    _init: function () {

                    },
                    _setOption: function(key, value) {
                        $.Widget.prototype._setOption.apply(this, arguments);
                    },
                    destroy: function() {
                        this._zoomDestroy();

                        this.$preview.unbind('mousedown');

                        this.$preview.slick('destroy');

                        $(this.$btn_full, this.$arrow_prev, this.$arrow_next, this.$btn_zoom_toggle).off().remove();

                        this.fotorama.destroy();

                        $(window).unbind('resize.productgallery' + this.id);

                        $.Widget.prototype.destroy.call(this);
                    }
                });

                $images.productGallery(options);

                this.destroy = function() {
                    $images.productGallery('destroy');
                };
            } else if($images.find('.tt-product-head__image-sheet').length) {
                function initZoom() {
                    var bp = 1024,
                        wind_w = window.innerWidth;

                    if(wind_w > bp) {
                        $images.find('img').elevateZoom({
                            zoomType: "inner",
                            cursor: "crosshair",
                            easing : true,
                            zoomWindowFadeIn: 500,
                            zoomWindowFadeOut: 500
                        });
                    }
                };

                function destroyZoom() {
                    var $zoomCont = $('body > .zoomContainer');

                    if($zoomCont.length) {
                        $.removeData($images.find('img'), 'elevateZoom');
                        $zoomCont.remove();
                    }
                };

                function debounce(func, wait, immediate) {
                    var timeout;
                    return function() {
                        var context = this, args = arguments;
                        var later = function() {
                            timeout = null;
                            if (!immediate) func.apply(context, args);
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) func.apply(context, args);
                    };
                };

                var myEfficientFn = debounce(function() {
                    destroyZoom();
                    initZoom();
                }, 500);

                $(window).on('resize.productimages', function() {
                    myEfficientFn();
                });

                initZoom();

                $images.addClass('tt-product-head__images--loaded');

                this.destroy = function() {
                    $(window).unbind('resize.productimages');
                    destroyZoom();
                };
            }

            return this;
        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.testimonials = {
    section: {
        init: function ($container) {
            var $testimonials = $container.filter('.tt-testimonials');

            $testimonials.each(function () {
                var $this = $(this),
                    $slider = $this.find('.tt-testimonials__slider');

                $slider.slick({
                    rtl: $('body').attr('dir') === 'rtl' ? true : false,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    speed: 1000,
                    autoplay: true,
                    autoplaySpeed: 2500,
                    fade: false
                });
            });
        },
        destroy: function() {

        }
    }
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.section.collection = {
    construct: function() {
        this.options = {};

        this.collection = null;
        this.collectionPresent = false;
        this.params = {};
        this.unallocatedСonstraint = [];
        this.paramsUrlSeparate = {
            'default': '+',
            'view': '-'
        };

        this.dom = {
            $listing_page: $('.tt-listing-page'),
            $filters: $('.tt-collection-param'),
            $unallocated: $('.tt-layer-nav__unallocated .tt-collection-param'),
            $current_tags: $('.tt-layer-nav__tags'),
            $products: $('.tt-product-view'),
            $categories: $('.tt-categories'),
            $options: $('.tt-listing-page__view-options'),
            $view: $('.tt-product-btn-vw'),
            $sort: $('.tt-vw-opt__sort'),
            $length: $('.tt-vw-opt__length'),
            $pagination: $('.tt-pagination'),
            $loadmore: $('.tt-loadmore'),
            $paginate_scroll: $('.tt-pagination-scroll'),
            $info: $('.tt-vw-opt__info'),
            $title: $('.tt-listing-page__title'),
            $links: $('.tt-listing-page__links'),
            $price: $('.tt-layer-nav__price-range'),
            $breadcrumbs: $('.tt-page__breadcrumbs'),
            $btn_filter: $('.tt-layer-nav__btn-filter')
        };

        if(this.dom.$loadmore.length) {
            this.pagination_type = 'load_more';
        } else if (this.dom.$paginate_scroll.length) {
            this.pagination_type = 'scroll';
        } else if (this.dom.$pagination.length) {
            this.pagination_type = 'classic';
        }

        this.parseUrl();
        this.saveParams();
        this.getParams();
        this.handlers();
        this.eventFilter();
        this.eventHistory();

        this.dom.$categories.trigger('openactive');
    },
    init: function() {
        this.build = new this.construct;
    },
    destroy: function() {

        this.dom.$categories.off();
        this.build = null;
    }
};

Mogo.section.collection.construct.prototype = $.extend({}, Mogo.section.collection.construct.prototype, {
    parseUrl: function() {
        var _self = this,
            url = decodeURIComponent(location.href) || location.href,
            cur_text = 'collections',
            pos = url.indexOf(cur_text),
            str = url.slice(pos + cur_text.length);

        str = str.split('?');

        var url_body = str[0],
            url_get = str[1];

        url_body = url_body.split('/');

        var collection = url_body[1],
            filter_body = url_body[2],
            params = {};

        if(filter_body) {
            filter_body = filter_body.split('+');
        }

        if(url_get) {
            var filter_get = {};

            url_get = url_get.split('&');

            $(url_get).each(function(key, value) {
                value = value.split('=');

                var k = value[0],
                    separate = (_self.paramsUrlSeparate.hasOwnProperty(k)) ? _self.paramsUrlSeparate[k] : _self.paramsUrlSeparate['default'];

                filter_get[k] = value[1].split(separate);
            });

            params = $.extend({}, filter_get);
        }

        if(Array.isArray(filter_body)) {
            if(!params['constraint']) params['constraint'] = [];

            params['constraint'] = $.merge(params['constraint'], filter_body);
        }

        this.collection = collection;
        this.params = params;
        this.unallocatedСonstraint = (Array.isArray(this.params['constraint'])) ? this.params['constraint'].slice() : [];

        this.current_url = url;
        this.collectionPresent = false;
    },
    buildUrl: function() {
        var _self = this,
            params = this.params,
            get = '',
            is_first_key = true;

        $.each(params, function(key, value) {
            if(!value.length) {
                delete params[key];
                return;
            }

            var separate = (_self.paramsUrlSeparate.hasOwnProperty(key)) ? _self.paramsUrlSeparate[key] : _self.paramsUrlSeparate['default'],
                is_first_value = true;

            if(is_first_key) is_first_key = false;
            else get += '&';

            get += key + '=';

            $.each(value, function(k, v) {
                if(is_first_value) is_first_value = false;
                else get += separate;

                v = v.trim();

                get += v;
            });
        });

        if(get.length) get = '?' + get;
        
        this.current_url = '/collections/' + this.collection + get;

        this.current_url = this.current_url.replace(/#/g,'').replace(/\s/ig, '-').replace(/\-+/g,'-');
    },
    setUrl: function(params) {
        this.buildUrl();

        history.pushState({foo: 'bar'}, this.current_url, this.current_url);
    },
    getParams: function() {
        var _self = this;

        this.params = {};

        this.dom.$filters.each(function() {
            var $this = $(this),
                property = $this.attr('data-tt-property') || 'constraint',
                params = $this.attr('data-tt-params');

            if(property === 'collection' && params) {
                _self.collection = params;
            } else if(params) {
                var params_obj = params.split(',');

                if(!Array.isArray(_self.params[property])) _self.params[property] = [];

                $.each(params_obj, function(key, value) {
                    var is_present = false;

                    value = value.trim();

                    $.each(_self.params[property], function(k, v) {
                        if(value === v.trim()) is_present = true;
                    });

                    if(!is_present) _self.params[property].push(value);
                });
            }
        });
    },
    saveParams: function(establish) {
        this.saveCategoryParams(establish);
        this.saveSortParams(establish);
        this.saveLengthParams(establish);
        this.saveViewParams(establish);
        this.savePriceParams(establish);
        this.addUnallocated();
        this.checkCollection();
    },
    saveCategoryParams: function(establish)  {
        var _self = this;

        this.dom.$categories.each(function() {
            var $this = $(this),
                $li = $this.find('li'),
                $a = $li.find('a'),
                arr = [];

            if(establish === true) {
                $li.removeClass('active');
            }

            $a.each(function() {
                var $this = $(this),
                    value = $this.attr('data-tt-value').trim().replace(' ', '-');

                if(value === _self.collection) {
                    if(establish === true) {
                        $this.parent().addClass('active');
                    }

                    arr.push(value);

                    _self.collectionPresent = true;
                } else {
                    $.each(_self.params['constraint'], function(k, v) {
                        v = v.trim();

                        if(value === v) {
                            if(establish === true) {
                                $this.parent().addClass('active');
                            }

                            _self.deleteFromUnallocated(value);

                            arr.push(value);
                        }
                    });
                }
            });

            $this.attr('data-tt-params', arr.join(', '));
        });
    },
    saveSortParams: function(establish) {
        var _self = this,
            $sort = this.dom.$sort,
            $options = $sort.find('option'),
            arr = [];

        if(establish === true) {
            $options.removeAttr('selected');
        }

        $options.each(function() {
            var $this = $(this),
                value = $this.attr('data-tt-value').trim().replace(' ', '-');

            $.each(_self.params['sort_by'], function(k, v) {
                v = v.trim();

                if(value === v) {
                    if(establish === true) {
                        $this.prop('selected', true);
                    }

                    arr.push(value);
                }
            });
        });

        $sort.attr('data-tt-params', arr.join(', '));
    },
    saveLengthParams: function(establish) {
        var _self = this,
            $length = this.dom.$length,
            $options = $length.find('option'),
            arr = [];

        if(establish === true) {
            $options.removeAttr('selected');
        }

        $options.each(function() {
            var $this = $(this),
                value = $this.attr('data-tt-value').trim().replace(' ', '-');

            $.each(_self.params['view'], function(k, v) {
                v = v.trim();

                if(value === v) {
                    if(establish === true) {
                        $this.prop('selected', true);
                    }

                    arr.push(value);
                }
            });
        });

        $length.attr('data-tt-params', arr.join(', '));
    },
    saveViewParams: function(establish) {
        var _self = this,
            $view = this.dom.$view,
            $inputs = $view.find('input'),
            arr = [],
            params = '';

        if(establish === true) {
            var $control = $($view.attr('data-control'));

            $inputs.each(function () {
                var view = $(this).attr('data-view-class');

                $control.removeClass(view);
            });

            $inputs.removeAttr('checked');
        }

        $inputs.each(function() {
            var $this = $(this),
                value = $(this).attr('data-tt-value').trim().replace(' ', '-');

            $.each(_self.params['view'], function(k, v) {
                v = v.trim();

                if(value === v) {
                    if(establish === true) {
                        $this.prop('checked', true);
                        $control.addClass($this.attr('data-view-class'));
                    }

                    arr.push(value);
                }
            });
        });

        params = arr.join(', ');

        if(establish === true && !params.length) {
            var default_params = $view.attr('data-tt-default'),
                $default_input = $inputs.filter('[data-tt-value="' + default_params + '"]');

            $default_input.prop('checked', true);

            $control.addClass($default_input.attr('data-view-class'));
        }

        $view.attr('data-tt-params', params);
    },
    savePriceParams: function(establish, reset) {
        if(!this.dom.$price.length) return;

        var $price = this.dom.$price,
            $input = $price.find('input'),
            min = $input.attr('data-min'),
            max = $input.attr('data-max'),
            set_from = min,
            set_to = max,
            filter_present = false;

        if(reset) {
            var slider = $input.data("ionRangeSlider");

            $price.removeAttr('data-tt-params');

            slider.update({
                from: min,
                to: max
            });
        } else {
            $.each(this.params['constraint'], function(k, v) {
                var str = 'rprice-',
                    index = v.indexOf(str);

                if(index !== -1) {
                    var price = v.replace(str, '').split('-');

                    set_from = price[0];

                    if(price[1]) {
                        set_to = price[1]
                    } else {
                        set_to = set_from;
                    }

                    if(set_from === min && set_to === max) {
                        $price.removeAttr('data-tt-params');
                    } else {
                        $price.attr('data-tt-params', v);
                    }

                    filter_present = true;
                }
            });

            if(!filter_present) {
                $price.removeAttr('data-tt-params');
            }

            if(establish) {
                var slider = $input.data("ionRangeSlider");

                slider.update({
                    from: set_from,
                    to: set_to
                });
            }
        }
    },
    deleteFromUnallocated: function(param) {
        var _self = this;

        $.each(this.unallocatedСonstraint, function(key, value) {
            if(value === param) {
                _self.unallocatedСonstraint.splice(key, 1);
            }
        });
    },
    addUnallocated: function() {
        var _self = this,
            $unallocated = this.dom.$unallocated;

        $.each(this.unallocatedСonstraint, function(k, v) {
            var index = v.indexOf('rprice-');

            if(index !== -1) {
                _self.unallocatedСonstraint.splice(index, 1);
            }
        });

        if($unallocated.hasClass('active') && this.unallocatedСonstraint.length) {
            $.each(this.unallocatedСonstraint, function(key, value) {
                var $add_filter = $('<a>').attr('href', '#' + value).attr('data-tt-value', value).html(value);

                $add_filter = $('<li>').addClass('active').append($add_filter);

                $unallocated.append($add_filter);
            });

            $unallocated.attr('data-tt-params', this.unallocatedСonstraint.join(', '));
            $unallocated.parent().removeClass('ttg-hidden');
        } else {
            $unallocated.html('');
            $unallocated.removeAttr('data-tt-params');
            $unallocated.parent().addClass('ttg-hidden');
        }
    },
    checkCollection: function() {
        var $collections = this.dom.$categories.filter('[data-tt-property="collection"]');

        if($collections.length && !this.collectionPresent && this.collection) {
            var collection = this.collection,
                collection_title = collection.replace(/-/gim, ' ').split(' ');

            for(var i = 0; i < collection_title.length; i++) {
                collection_title[i] = collection_title[i].charAt(0).toUpperCase() + collection_title[i].substr(1).toLowerCase();
            }

            collection_title = collection_title.join(' ');

            var $add_collection = $('<a>').attr('href', '#' + collection).attr('data-tt-value', collection).html(collection_title);

            $add_collection = $('<li>').addClass('active').append($add_collection);

            $collections.append($add_collection);
        }
    },
    addCurrentTags: function() {
        var $current_tags = this.dom.$current_tags,
            show_rprice = $current_tags.attr('data-show-rprice'),
            constraint = (Array.isArray(this.params['constraint'])) ? this.params['constraint'] : [];

        if($current_tags.length) {
            $current_tags.html('');

            if(constraint.length) {
                $current_tags.parent().removeClass('ttg-hidden');

                $.each(constraint, function(key, value) {
                    if(show_rprice === 'false' && value.indexOf('rprice-') !== -1) {
                        return;
                    }

                    var $tag = $('<span>').attr('data-tt-value', value).html(value + '<i class="icon-cancel-1"></i>');

                    $current_tags.append($tag);
                });

                if(!$current_tags.find('[data-tt-value]').length) {
                    $current_tags.parent().addClass('ttg-hidden');
                }
            } else {
                $current_tags.parent().addClass('ttg-hidden');
            }
        }
    },
    ajaxRequest: function(params) {
        var _self = this;

        $.ajax({
            type: 'GET',
            url: this.current_url,
            cache: false,
            success: function (content) {
                _self.replaceContent(content, params);
            },
            error: function (jqXHR, exception) {
                console.log('Ajax error');
                console.log('Error status: ' + jqXHR.status);
            }
        });
    },
    replaceContent: function(content, params) {
        var _self = this,
            $content = $(content),
            $sticky = $('.tt-layout__sidebar.tt-sticky-block');

        params = params || {};

        function replaceProducts(params) {
            var $products = _self.dom.$products,
                $new_products = $content.find('.tt-product-view');

            if(_self.pagination_type === 'load_more' && params.save_products) {
                $products.append($($new_products.html()));
            } else if (_self.pagination_type === 'scroll' && params.save_products) {
                $products.append($($new_products.html()));
            } else {
                $products.html($new_products.html());
            }

            Mogo.productScroll(true);
        };

        function replaceElems() {
            var $listing = _self.dom.$listing_page,
                $elems = $listing.find('[data-collection-replace]');

            if(params.paginate) $elems = $elems.filter('[data-collection-replace="paginate"]');

            $elems.each(function() {
                var $elem = $(this),
                    className = $elem.attr('class');

                $elem.html($content.find('[class="' + className + '"]').html());
            });
        };

        this.dom.$products.addClass('ttg-loading');

        replaceProducts(params);

        replaceElems();

        if($sticky.hasClass('initialize')) {
            $sticky.stickySidebar('updateSticky');
        }

        this.dom.$products.removeClass('ttg-loading').removeAttr('style');

        if(this.dom.$loadmore.length) {
            this.dom.$loadmore.removeClass('btn__state--wait');
        }

        if(params.complete) {
            params.complete();
        }
    },
    refreshParams: function(params) {
        this.dom.$products.addClass('ttg-loading');

        params = params || {};

        this.getParams();

        if(!params.skip_history) {
            this.setUrl();
        } else {
            this.buildUrl();
        }

        this.ajaxRequest(params);
        this.addCurrentTags();
    },
    eventHistory: function() {
        var _self = this;

        $(window).on('popstate', function() {
            _self.dom.$products.addClass('ttg-loading');

            _self.parseUrl();
            _self.ajaxRequest();
            _self.saveParams(true);
            _self.addCurrentTags();
        });
    },
    eventFilter: function() {
        var _self = this,
            $filters = this.dom.$filters;

        $filters.on('filterchange', function() {
            _self.refreshParams();
        });
    },
    categoryHandler: function() {
        var _self = this,
            $categories = this.dom.$categories,
            breakpoint = 1024,
            anim_duration = 500,
            interval;

        $categories.on('click', 'a', function (e) {
            var $this = $(this),
                $category = $this.parents('.tt-categories'),
                property = $category.attr('data-tt-property'),
                $li = $this.parent(),
                params = [];

            if((property === 'collection' && !$li.hasClass('active')) || ($category.attr('data-radio') && !$li.hasClass('active'))) {
                _self.dom.$products.addClass('ttg-loading');

                $category.find('li').removeClass('active');

                $li.filter('.active').not('.tt-categories__open').find('> i').trigger('click');
            } else if ($category.attr('data-radio') && $li.hasClass('active')) {
                _self.dom.$products.addClass('ttg-loading');
            } else if (property === 'collection' && $li.hasClass('active')) {
                e.preventDefault();
                return false;
            }

            if(property === 'collection' && !$li.hasClass('active')) {
                $categories
                    .not($category)
                    .removeAttr('data-tt-params')
                    .find('li')
                    .removeClass('active');

                _self.savePriceParams(false, true);
            }

            $li.toggleClass('active');

            //start filter
            $category.find('li').each(function() {
                var $this = $(this);

                if($this.hasClass('active')) params.push($this.find('> a').attr('data-tt-value'));
            });

            $category.attr('data-tt-params', params.join(', '));

            _self.dom.$pagination.removeAttr('data-tt-params');
            _self.dom.$loadmore.removeAttr('data-tt-params');

            _self.refreshParams();
            //end filter

            e.preventDefault();
            return false;
        });

        $categories.on('click.', '.tt-categories__next', function () {
            var $this = $(this),
                $li = $this.parent(),
                $ul = $li.find('> ul').first(),
                wind_w = window.innerWidth,
                desktop = wind_w > breakpoint;

            $li.toggleClass('tt-categories__open');

            if($ul.length) {
                if($li.hasClass('tt-categories__open')) {
                    if(desktop) {
                        clearInterval(interval);
                        interval = setInterval(function () {
                            $(window).trigger('stickySide.position');
                        }, 5);
                    }

                    $ul.velocity('stop').removeAttr('style').velocity( 'slideDown', {
                        duration: anim_duration,
                        complete: function () {
                            clearInterval(interval);
                        }
                    });
                } else {
                    $ul.velocity('stop').velocity( 'slideUp', {
                        duration: anim_duration,
                        complete: function () {
                            $(window).trigger('stickySide.position');
                        }
                    });
                    $ul.find('ul').velocity('stop').velocity( 'slideUp', anim_duration );
                    $ul.find('li').removeClass('tt-categories__open');
                }
            }
        });

        function openActive() {
            var $categories_active = $categories.find('li.active');

            $categories_active.addClass('active');

            $categories_active
                .add($categories_active.parents('.tt-categories li'))
                .addClass('tt-categories__open')
                .find('> ul').show();
        };

        openActive();

        $categories.on('openactive', function() {
            openActive();
        });
    },
    viewHandler: function() {
        var _self = this,
            $view = this.dom.$view,
            $control = $($view.attr('data-control')),
            $input = $view.find('input'),
            params = '';

        $input.on('change', function () {
            var $this = $(this);

            $input.each(function () {
                var view = $(this).attr('data-view-class');

                $control.removeClass(view);
            });

            $control.addClass($this.attr('data-view-class'));

            //start filter
            params = $view.find('input:checked').attr('data-tt-value');

            if(params) {
                $view.attr('data-tt-params', params);
            } else {
                $view.removeAttr('data-tt-params');
            }

            _self.dom.$loadmore.removeAttr('data-tt-params');

            _self.refreshParams();
            //end filter
        });
    },
    sortHandler: function() {
        var  _self = this,
            $sort = this.dom.$sort;

        $sort.find('select').on('change', function() {
            //start filter
            $sort.attr('data-tt-params', $sort.find('option:selected').attr('data-tt-value'));

            _self.dom.$loadmore.removeAttr('data-tt-params');

            _self.refreshParams();
            //end filter
        });
    },
    lengthHandler: function() {
        var  _self = this,
            $length = this.dom.$length;

        $length.find('select').on('change', function() {
            //start filter
            $length.attr('data-tt-params', $length.find('option:selected').attr('data-tt-value'));

            _self.dom.$pagination.removeAttr('data-tt-params');
            _self.dom.$loadmore.removeAttr('data-tt-params');

            _self.refreshParams();
            //end filter
        });
    },
    paginateHandler: function() {
        var _self = this,
            $pagination = this.dom.$pagination;

        $pagination.on('click', 'a', function(e) {
            var $this = $(this),
                $elem = ($this.hasClass('btn')) ? $this : $this.parent(),
                value = +$elem.attr('data-tt-value');

            //start filter
            $pagination.attr('data-tt-params', value);

            _self.refreshParams({
                paginate: true
            });
            //end filter

            e.preventDefault();
            return false;
        });
    },
    loadmoreHandler: function() {
        var _self = this,
            $loadmore = this.dom.$loadmore;

        $loadmore.on('click', 'a', function(e) {
            var $this = $(this),
                value = +$this.attr('data-tt-value');

            $this.addClass('btn__state--wait');

            //start filter
            $loadmore.attr('data-tt-params', value);

            _self.refreshParams({
                paginate: true,
                skip_history: true,
                save_products: true
            });

            //$loadmore.removeAttr('data-tt-params');
            //end filter

            e.preventDefault();
            return false;
        });
    },
    paginateScrollHandler: function() {
        var _self = this,
            $paginate_scroll = this.dom.$paginate_scroll;

        $(window).on('scroll.paginateScroll', function() {
            var pos = $paginate_scroll[0].getBoundingClientRect(),
                $value = $paginate_scroll.find('[data-tt-value]');

            if(!$value.hasClass('ttg-hidden') && pos.bottom - window.innerHeight + 40 < 0 && !$value.hasClass('waiting')) {
                $value.addClass('waiting');

                var value = +$value.attr('data-tt-value');

                $paginate_scroll.attr('data-tt-params', value);

                _self.refreshParams({
                    paginate: true,
                    skip_history: true,
                    save_products: true
                });
            }
        });
    },
    currentTagsHandler: function() {
        var _self = this,
            $current_tags = this.dom.$current_tags;
        
        $current_tags.on('click', 'i', function() {
            _self.dom.$products.addClass('ttg-loading');

            var $this = $(this),
                $tag = $this.parent(),
                params = _self.params,
                del_param = $tag.attr('data-tt-value');

            del_param = del_param.trim();

            $.each(params, function(key, value) {
                $.each(value, function(k, v) {
                    v = v.trim();

                    if(del_param == v) {
                        params[key].splice(k, 1);
                        return false;
                    }
                });
            });

            _self.setUrl();
            _self.ajaxRequest();
            _self.saveParams(true);
            _self.addCurrentTags();
        });
    },
    priceSliderHandler: function() {
        var _self = this,
            $range = this.dom.$price,
            $input = $range.find('> input'),
            $sidebar_content = $('.tt-sidebar__content'),
            breakpoint = 1024;

        if($input.length > 0) {
            $input.ionRangeSlider({
                type: "double",
                nabled: true,
                prettify_enabled: false,
                onFinish: function (data) {
                    if(window.innerWidth <= breakpoint) {
                        $sidebar_content.perfectScrollbar();
                    }

                    if(data.from === data.min && data.to === data.max) {
                        $range.removeAttr('data-tt-params');
                    } else {
                        var price = (data.from === data.to) ? data.from : data.from + '-' + data.to;

                        $range.attr('data-tt-params', 'rprice-' + price);
                    }

                    _self.refreshParams();
                }
            });

            $range.find('.irs-slider, .irs-from, .irs-to').on('mousedown touchstart', function() {
                if($sidebar_content.hasClass('ps') && window.innerWidth <= breakpoint) {
                    $sidebar_content.perfectScrollbar('destroy').removeClass('ps');
                }
            });
        }
    },
    btnFilterHandler: function() {
        var _self = this;

        this.dom.$btn_filter.on('click', function() {
            _self.refreshParams();
        });
    },
    handlers: function() {
        this.categoryHandler();
        this.viewHandler();
        this.sortHandler();
        this.lengthHandler();
        this.currentTagsHandler();
        this.priceSliderHandler();
        this.btnFilterHandler();

        if(this.pagination_type === 'load_more') {
            this.loadmoreHandler();
        } else if(this.pagination_type === 'scroll') {
            this.paginateScrollHandler();
        } else {
            this.paginateHandler();
        }
    }
});
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.cart = {
    construct: function() {
        this.settings = {
            max_products: 3
        };

        this.dom = {
            $mini_cart: $('.tt-header__cart'),
            $popup_tocart: $('.tt-add-to-cart'),
            $count: $('#tt-cart-count'),
            $list: $('.tt-header__cart-content > ul'),
            $subtotal: $('.tt-header__cart-subtotal > span'),
            $footer: $('.tt-header__cart-footer'),
            $currency: $('#currencies'),
            $pd_expl: $('.tt-header__cart-example'),
            $empty: $('.tt-header__cart-empty'),
            $more: $('.tt-header__cart-more')
        };

        this.attr = {
            popup_enable: 'data-active'
        };

        this.dom.$pd_expl = this.dom.$pd_expl.remove().removeClass('tt-header__cart-example');

        $(document).on('click', '.mfp-content [data-action="close"]', function() {
            $(this).parents('.mfp-content').find('.mfp-close').trigger('click');
        });
    },
    init: function() {
        Mogo.cart = new this.construct;
    }
};

Mogo.cart.construct.prototype = $.extend({}, Mogo.cart.construct.prototype, {
    addItem: function(obj) {
        var _self = this;

        $.getJSON({
            url: '/cart/add.js',
            type: 'POST',
            data: obj.data,
            success: function(data) {
                var popup_enable = _self.dom.$popup_tocart.attr(_self.attr.popup_enable);

                if(data.id > 0) {
                    if(popup_enable === 'true' && obj.$btn) {
                        _self.showPopup(obj.$btn);
                    }

                    _self.update();
                }

                if(obj.callback && typeof obj.callback === 'function') {
                    obj.callback(data);
                }
            },
            error: function(e) {
                if(e.responseJSON.status === 422) {
                    alert(e.responseJSON.description)
                }

                if(obj.callback && typeof obj.callback === 'function') {
                    obj.callback({}, 'abort');
                }
            }
        });
    },
    removeItem: function(id, callback) {
        this.changeItem(id, 0, callback);
    },
    changeItem: function(id, quantity, callback) {
        var _self = this;

        $.getJSON({
            url: '/cart/change.js',
            type: 'POST',
            data: 'quantity=' + quantity + '&id=' + id,
            success: function(data) {
                _self.update();

                if(callback && typeof callback === 'function') {
                    callback(data);
                }
            }
        });
    },
    remove: function(callback) {
        var _self = this;

        $.getJSON({
            url: '/cart/clear.js',
            type: 'POST',
            success: function(data) {
                _self.update();

                if(callback && typeof callback === 'function') {
                    callback(data);
                }
            }
        });
    },
    showPopup: function($btn) {
        var $popup_tocart = this.dom.$popup_tocart;

        if($popup_tocart.length) {
            if($btn) $btn.trigger('blur');

            $.magnificPopup.open({
                mainClass: 'mfp-with-zoom',
                removalDelay: 300,
                closeMarkup: '<button title="%title%" type="button" class="mfp-close icon-cancel"></button>',
                items: [
                    {
                        src: $popup_tocart,
                        type: 'inline'
                    }
                ]
            });
        }
    },
    update: function() {
        var _self = this,
            $list = this.dom.$list;

        if($list.length) {
            $list.addClass('ttg-loading');

            $.getJSON("/cart.js", function (data) {
                _self.updatePopup(data);
                _self.updateCount(data.item_count);

                $list.removeClass('ttg-loading');
            })
        }
    },
    updatePopup: function (cart) {
        var $mini_cart = this.dom.$mini_cart,
            $list = this.dom.$list,
            $subtotal = this.dom.$subtotal,
            $footer = this.dom.$footer,
            $pd_expl = this.dom.$pd_expl,
            $empty = this.dom.$empty,
            $more = this.dom.$more,
            money_format = theme.moneyFormat,
            max_products = this.settings.max_products,
            all_string = theme.strings.cartPopupAll.replace('{{count}}', cart.item_count);

        $subtotal.text('');
        $more.find('a').text(all_string);

        $list.find('li').not($more).not($empty).remove();

        if(cart.item_count > 0) {
            if(cart.items.length > max_products) {
                $more.removeClass('ttg-hidden');
            } else {
                $more.addClass('ttg-hidden');
            }
            
            var $pds_wrap = $('<ul>');

            $.each(cart.items, function(i) {
                if(i >= max_products) return false;

                var $pd = $pd_expl.clone(),
                    $pd_image = $pd.find('img'),
                    $pd_info = $pd.find('p'),
                    $pd_title = $pd_info.find('a'),
                    $pd_price = $pd.find('.tt-header__cart-price-val'),
                    $pd_price_count = $pd.find('.tt-header__cart-price-count'),
                    $pd_edit = $pd.find('.tt-header__cart-edit'),
                    $pd_links = $pd_title.add($pd_edit).add($pd_image.parents('a')),
                    $pd_count = $pd.find('.prdbut__cart-count');

                $pd.attr('data-prdbut-id', this.variant_id).attr('data-prdbut-selected', true);
                $pd_title.text(this.product_title);
                $pd_links.attr('href', this.url);
                $pd_image.attr('src', slate.Image.getSizedImageUrl (this.image, '104x'));
                $pd_image.attr('srcset', slate.Image.getSizedImageUrl (this.image, '104x') + ' 1x, ' + slate.Image.getSizedImageUrl (this.image, '208x') + ' 2x');
                $pd_image.attr('alt', this.product_title);
                $pd_price.html(Shopify.formatMoney(this.price * 1.2, money_format));
                $pd_price_count.html(this.quantity);
                $pd_count.val(this.quantity);

                if (this.variant_options.length > 0 && this.variant_title != null ) {
                    var $variants = $('<span>').addClass('tt-header__cart-color').html(this.variant_title);
                    $pd_info.append($variants);
                }

                if (this.properties && this.properties['Notes']) {
                    var $notes = $('<span>').addClass('tt-header__cart-color').html('<span>' + $mini_cart.attr('data-t-notes') + '</span> ' + this.properties['Notes']);
                    $pd_info.append($notes);
                }

                $pds_wrap.append($pd);
            });

            $pds_wrap.children().insertBefore($more);
            $pds_wrap.remove();

            $subtotal.html(Shopify.formatMoney(cart.total_price * 1.2, money_format));
            this.updateCurrency();
            $footer.removeClass('ttg-hidden');
            $empty.addClass('ttg-hidden');
        } else {
            $more.addClass('ttg-hidden');
            $empty.removeClass('ttg-hidden');
            $footer.addClass('ttg-hidden');
        }
    },
    updateCurrency: function() {
        var $active_currency = this.dom.$currency.find('li.active');

        $active_currency.trigger('click');
    },
    updateCount: function(count) {
        var $count = this.dom.$count;

        $count.text(count);

        if(count > 0) {
            $count.removeClass('ttg-hidden');
        } else {
            $count.addClass('ttg-hidden');
        }
    }
});
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/
 * support@tonytemplates.com
 */

Mogo.wishlistPage = {
    construct: function() {
        var $body = $('body');

        this.settings = {
            expl_class: 'tt-wishlist__product-example'
        };

        this.dom = {
            $wsl: $('.tt-wishlist'),
            products: $('.tt-wishlist__products'),
            $empty: $('.tt-wishlist__empty'),
            $footer: $('.tt-wishlist__footer'),
            $count: $('.tt-header__btn-wishlist > a > span')
        };

        this.selector = {

        },

        this.attr = {

        };

        this.params = {
            domain: $body.attr('data-prdbut-domain'),
			main_domain: $body.attr('data-prdbut-main-domain'),
            customer_id: $body.attr('data-prdbut-customer-id')
        };

        if(this.dom.$wsl.length) {
            this.addContent();
            //this.checkPage();
        }
    },
    init: function() {
        Mogo.wishlistPage = new this.construct;
    }
};

Mogo.wishlistPage.construct.prototype = $.extend({}, Mogo.wishlistPage.construct.prototype, {
    addContent: function() {
        var _self = this,
            $wsl = this.dom.$wsl,
            params = Mogo.wishlistParams,
            cart = $('body').attr('data-prdbut-cart-id'),
            items = (params) ? params.ato_wishlist : [];

        cart = cart ? cart.split(', ') : [];

        if(!$wsl.length || !items.length) return;

        var $pds = this.dom.products,
            $pd_expl = $pds.find('.' + this.settings.expl_class).remove().removeClass(this.settings.expl_class),
            $pds_wrap = $('<div>');

        (function add_pd(idx) {
            idx = idx || 0;

            if(!items[idx]) {
                $pds.append($pds_wrap.children());
                $pds_wrap.remove();
                Mogo.currency.update();
                $wsl.removeClass('ttg-loading');
                return;
            }

            var pd = items[idx],
                url = '/products/' + pd.product_handle + '.js';

            $.getJSON(url, function(data_pd) {
                var variant = null;

                $.each(data_pd.variants, function() {
                    if(+this.id === +pd.product_variant_id) {
                        variant = this;
                    }
                });

                var id = pd.product_variant_id ,
                    handle = pd.product_handle,
                    url = data_pd.url,
                    title = data_pd.title,
                    options = (variant && variant.title !== 'Default Title') ? variant.title : null,
                    image = (variant && variant.featured_image) ? variant.featured_image.src : data_pd.featured_image,
                    price = variant ? variant.price : data_pd.price,
                    compare_at_price = variant ? variant.compare_at_price : data_pd.compare_at_price,
                    available = variant ? variant.available : data_pd.available;

                var $pd = $pd_expl.clone(),
                    $pd_image = $pd.find('.tt-wishlist__product_image img'),
                    $pd_info = $pd.find('.tt-wishlist__product_info'),
                    $pd_title = $pd_info.find('a p'),
                    $pd_price = $pd.find('.tt-wishlist__product_price .tt-price'),
                    $pd_links = $($pd_image).add($pd_title).parents('a'),
                    $pd_status = $pd.find('.tt-wishlist__product_status'),
                    $pd_tocart = $pd.find('.tt-wishlist__product_to-cart');

                if(variant) $pd.attr('data-prdbut-selected', 'true');
                $pd.attr('data-prdbut-id', id);
                $pd.attr('data-prdbut-handle', handle);
                $pd_image.attr('src', image).attr('alt', title);
                $pd_title.html(title);
                $pd_links.attr('href', url);
                $pd_price.append($('<span>').addClass('money').html(Shopify.formatMoney(price, theme.moneyFormat)));

                if(options) {
                    $pd_info.append($('<p>').html(options));
                }

                if(compare_at_price) {
                    $pd_price.addClass('tt-price--sale')
                        .append($('<span>').addClass('money').html(Shopify.formatMoney(compare_at_price, theme.moneyFormat)));
                }

                if(available) {
                    var $pd_tocart_btn = $pd_tocart.find('a');

                    $pd_status.find('.out-stock').remove();
                    $pd_tocart_btn.attr('href', url);
                    
                    if(!variant) {
                        $pd_tocart_btn.find('span').text($pd_tocart_btn.attr('data-select-variant-text'));
                    }

                    $.each(cart, function() {
                        if(+variant.id === +this) {
                            $pd_tocart_btn.addClass('prdbut__btn--active tt-btn__state--active');
                        }
                    });
                } else {
                    $pd_status.find('.in-stock').remove();
                    $pd_tocart.remove();
                }

                $pds_wrap.append($pd);

                add_pd(++idx);
            });
        })();
    },
    removeItem: function($pd) {
        var $wsl = this.dom.$wsl,
            $pd = $pd.closest('.prdbut__product');

        $wsl.addClass('ttg-loading');

        $pd.remove();

        this.checkEmpty();

        $wsl.removeClass('ttg-loading');
    },
    clear: function() {
        var $wsl = this.dom.$wsl,
            $pds = this.dom.products;

        $wsl.addClass('ttg-loading');

        $pds.html('');

        this.checkEmpty();

        $wsl.removeClass('ttg-loading');
    },
    checkEmpty: function() {
        var $pds = this.dom.products,
            $empty = this.dom.$empty,
            $footer = this.dom.$footer;

        if($pds.children().length) {
            $empty.addClass('ttg-hidden');
            $footer.removeClass('ttg-hidden');
        } else {
            $pds.remove();
            $empty.removeClass('ttg-hidden');
            $footer.addClass('ttg-hidden');
        }
    },
    checkPage: function() {
        //_self.saveData = (typeof data_pd === 'object') ? JSON.stringify(data_pd) : null;

        /*$(window).on('focus', function() {

        });*/
    }
});



/*return false;

 function set_count(removeAll, $pd) {
 var count = +$wsl_count.html();

 if(!removeAll && --count > 0) {
 $wsl_count.html(count);

 if($pd) $pd.remove();
 } else {
 $wsl_count.remove();

 $wsl.children().not($wsl_empty).remove();
 $wsl_empty.removeClass('ttg-hidden');
 }
 };

 //del product
 $wsl.on('click', '.tt-wishlist__product_del a', function(e) {
 $wsl.addClass('ttg-loading');

 var $pd = $(this).parents('.tt-wishlist__product'),
 pd_id = $pd.data('variant-id'),
 url = 'https://mogoplus.tonytemplates.com/wishlist/delete',
 data = {
 "ato-shop-domain": shop_domain,
 "ato-customer-id" : customer_id,
 "ato-product-id" :  pd_id
 };

 $.post(url, data, function(data) {
 console.log(data)
 if(data.status === 'OK') {
 set_count(false, $pd);
 }

 $wsl.removeClass('ttg-loading');
 });

 e.preventDefault();
 return false;
 });

 //del all products
 $wsl.on('click', '.ato-clear-wishlist', function(e) {
 $wsl.addClass('ttg-loading');

 var url = 'https://mogoplus.tonytemplates.com/wishlist/deleteall',
 data = {
 "ato-shop-domain": shop_domain,
 "ato-customer-id" : customer_id
 };

 $.post(url, data, function(data) {
 if(data.status === 'OK') {
 set_count(true);
 }

 $wsl.removeClass('ttg-loading');
 });
 });*/
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.wishlist = {
	construct: function() {
		var $body = $('body');

		this.settings = {

		};

		this.dom = {
			$wishlist_page: $('.tt-wishlist'),
			$count: $('.tt-header__btn-wishlist')
		};

		this.attr = {
			count: 'data-count'
		};

		this.params = {
			domain: $body.attr('data-prdbut-domain'),
			main_domain: $body.attr('data-prdbut-main-domain'),
			customer_id: $body.attr('data-prdbut-customer-id')
		};
	},
	init: function() {
		Mogo.wishlist = new this.construct;
	}
};

Mogo.wishlist.construct.prototype = $.extend({}, Mogo.wishlist.construct.prototype, {
	addItem: function(id, handle, callback) {
		var _self = this,
			domain = this.params.domain,
			main_domain = this.params.main_domain,
			customer_id = this.params.customer_id;

		var url = 'https://mogoplus.tonytemplates.com/wishlist/add',
			data = {
				'shop': domain,
				'ato-shop-domain': domain,
				'ato-shop-main-domain': main_domain,
				'ato-customer-id' : customer_id,
				'ato-product-id' :  id,
				'ato-product-handle': handle
			};

		$.post(url, data, function(data) {
			if(data.status === 'OK') {
				_self.updateCount('up');
			}

			if(callback && typeof callback === 'function') {
				callback(data);
			}
		});
	},
	removeItem: function(id, handle, callback, $pd) {
		var _self = this,
			customer_id = this.params.customer_id,
			domain = this.params.domain,
			main_domain = this.params.main_domain,
			$wsl = this.dom.$wishlist_page,
			is_wsl_page = ($wsl.find($pd).length) ? true : false;

		if(is_wsl_page) $wsl.addClass('ttg-loading');

		var url = 'https://mogoplus.tonytemplates.com/wishlist/delete',
			data = {
				'shop': domain,
				'ato-shop-domain': domain,
				'ato-shop-main-domain': main_domain,
				'ato-customer-id' : customer_id,
				'ato-product-id' :  id,
				'ato-product-handle': handle
			};

		$.post(url, data, function(data) {
			if(is_wsl_page) {
				Mogo.wishlistPage.removeItem($pd);
			}

			if(data.status === 'OK') {
				_self.updateCount('down');
			}

			if(callback && typeof callback === 'function') {
				callback(data);
			}
		});
	},
	clear: function(callback, $pd) {
		var _self = this,
			customer_id = this.params.customer_id,
			domain = this.params.domain,
			main_domain = this.params.main_domain,
			$wsl = this.dom.$wishlist_page,
			is_wsl_page = $wsl.length ? true : false;

		if(is_wsl_page) $wsl.addClass('ttg-loading');

		var url = 'https://mogoplus.tonytemplates.com/wishlist/deleteall',
			data = {
				'shop': domain,
				'ato-shop-domain': domain,
				'ato-shop-main-domain': main_domain,
				'ato-customer-id' : customer_id
			};

		$.post(url, data, function(data) {
			if(is_wsl_page) {
				Mogo.wishlistPage.clear();
			}

			if(data.status === 'OK') {
				_self.updateCount('clear');
			}

			if(callback && typeof callback === 'function') {
				callback(data);
			}
		});
	},
	updateCount: function(act) {
		var $count = this.dom.$count,
			count = +$count.attr(this.attr.count),
			$span = $count.find('> span');

		if(+count === 0 && !$span.length) {
			$span = $('<span>').appendTo($count);
		}

		switch(act) {
			case 'up':
				++count;
				break;
			case 'down':
				--count;
				break;
			case 'clear':
				count = 0;
				break;
		}

		$span.text(count);
		$count.attr(this.attr.count, count);

		if(count > 0) {
			$span.removeClass('ttg-hidden');
		} else {
			$span.addClass('ttg-hidden');
		}
	}
});

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/
 * support@tonytemplates.com
 */

Mogo.quickview = {
    construct: function() {

    },
    init: function() {
        Mogo.quickview = new this.construct;
    }
};

Mogo.quickview.construct.prototype = $.extend({}, Mogo.quickview.construct.prototype, {
    show: function(handle, callback, $btn) {
        var url = 'products/' + handle,
            data = 'view=ajax',
			qvUrl = 'https://' + window.location.hostname + '/' + url,
            $qv;

        $.get(qvUrl, data, function(data) {
            if($btn) $btn.trigger('blur');

            var gallery;

            $.magnificPopup.open({
                mainClass: 'mfp-with-zoom mfp-qv',
                removalDelay: 300,
                closeMarkup: '<button title="%title%" type="button" class="mfp-close icon-cancel"></button>',
                items: [
                    {
                        src: $(data),
                        type: 'inline'
                    }
                ],
                callbacks: {
                    beforeOpen: function() {
                        var $body = $('body'),
                            $pd_images = $('.tt-product-page .tt-product-head__images'),
                            is_zoom = $pd_images.find('.tt-product-head__image-main').hasClass('fotorama--zoom'),
                            scrollW,
                            $scrlBl = $('<div>').css({
                                overflowY: 'scroll',
                                width: '50px',
                                height: '50px',
                                visibility: 'hidden'
                            });

                        this.is_zoom = is_zoom;

                        if(is_zoom) $pd_images.productGallery('zoomToggle', 'off');

                        $body.append($scrlBl);
                        scrollW = $scrlBl[0].offsetWidth - $scrlBl[0].clientWidth;
                        $scrlBl.remove();

                        $body.addClass('tt-qv-open');
                        $('.tt-header.tt-header__sticky').css({ paddingRight: scrollW });
                    },
                    open: function () {
                        var $qv = $('.tt-qv'),
                            $qv_images = $qv.find('.tt-product-head__images');

                        $(window).on('resize.qv qv', function() {
                            $qv.css({ 'max-height': window.innerHeight - 40 });
                        });

                        $(window).trigger('qv');

                        gallery = Mogo.productGLR.section.init({
                            slick: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                                vertical: false,
                                verticalSwiping: false
                            }
                        }, $qv_images);

                        Mogo.countdown('.tt-qv .tt-product-head__countdown');

                        /*Mogo.stickyBlock.section.init({
                            topSpacing: 0
                        }, $qv.find('.tt-sticky-block'));*/
                    },
                    close: function() {
                        var $pd_images = $('.tt-product-page .tt-product-head__images');

                        $(window).unbind('resize.qv qv');

                        $('body').removeClass('tt-qv-open');
                        $('.tt-header').removeAttr('style');

                        gallery.destroy();

                        if(this.is_zoom) $pd_images.productGallery('zoomToggle', 'on');
                    }
                }
            });

            if(callback && typeof callback === 'function') {
                callback(data);
            }
        });
    }
});
Mogo.productController = {
    construct: function() {
        this.settings = {
            variants: 'variants',
            variants_info: '_',
            variant_info_default_id: 'default_variant_id',
            variants_info_replace: '_replace',
            variants_info_visible: '_visible',
            btn_process_class: 'prdbut__btn--process',
            btn_active_class: 'prdbut__btn--active',
            visible_disabled_class: 'prdbut__visible--disabled',
            product_page_class: 'prdbut__product--page',
            variant_get_param: 'variant'
        };

        this.dom = {
            $prdbut: $('.prdbut'),
            $body: $('body')
        };

        this.selector = {
            product: '.prdbut__product',
            product_page: '.' + this.settings.product_page_class,
            option: '.prdbut__option',
            option_select: '.prdbut__option--select',
            is_available: '.prdbut__show-if-available',
            image: '.prdbut__image',
            gallery: '.prdbut__gallery',

            cart_add: '.prdbut__cart-add',
            cart_del: '.prdbut__cart-del',
            cart_toggle: '.prdbut__cart-toggle',
            cart_count: '.prdbut__cart-count',
            cart_notes: '.prdbut__cart-notes',
            cart_clear: '.prdbut__cart-clear',

            wsl_add: '.prdbut__wsl-add',
            wsl_del: '.prdbut__wsl-del',
            wsl_toggle: '.prdbut__wsl-toggle',
            wsl_clear: '.prdbut__wsl-clear',

            qv: '.prdbut__qv'
        };

        this.attr = {
            handle: 'data-prdbut-handle',
            obj: 'data-prdbut-variants',
            variant_current: 'data-prdbut-current',
            variant_selected: 'data-prdbut-selected',
            variant_id: 'data-prdbut-id',
            option_group: 'data-prdbut-group',
            option_value: 'data-prdbut-value',
            check_wsl: 'data-prdbut-wishlist-id',
            check_cart: 'data-prdbut-cart-id',
            replace_elem: 'data-prdbut-replace',
            visible_elem: 'data-prdbut-visible'
        };

        this._variantsHandlers();
        this._tocartHandlers();
        this._wishlistHandlers();
        this._quickviewHandlers();
        this._eventHistory();

        $('body').on('click', '.tt-product.tt-product__view-overlay .tt-product__hover', function(e) {
            if(!$(e.target).closest('a').length && !$(e.target).closest('.tt-product__option').length) {
                var url = $(this).parents('.tt-product').find('.tt-product__buttons_cart').attr('href');

                if(url) {
                    window.location.href = url;
                }
            }
        });
    },
    init: function() {
        this.build = new this.construct;
    },
    destroy: function() {

        this.dom.$prdbut.off();

        this.build = null;
    }
};

Mogo.productController.construct.prototype = $.extend({}, Mogo.productController.construct.prototype, {
    _variantsHandlers: function() {
        var _self = this,
            _product = this.selector.product,
            _image = this.selector.image,
            _obj = this.attr.obj,
            _current = this.attr.variant_current,
            _option = this.selector.option,
            _group = this.attr.option_group,
            _value = this.attr.option_value,
            _default = this.settings.variant_info_default_id,
            _variants = this.settings.variants,
            _info = this.settings.variants_info;

        function fitVariants(current_obj, variants_arr) {
            var fit_arr = [],
                variants_arr = variants_arr.slice();

            $.each(current_obj, function(k, v) {
                for(var i = 0; i < variants_arr.length; i++) {
                    if(variants_arr[i][k] === v) {
                        fit_arr.push(variants_arr[i]);
                        variants_arr.splice(i, 1);
                        i--;
                    }
                }
            });

            return fit_arr;
        };

        function activeVariant(current_obj, fit_arr) {
            var active_obj = null;

            $.each(fit_arr, function() {
                var variant = _self._methods._cloneObj(this);

                delete variant[_info];

                if(_self._methods._isEqual(current_obj, variant)) {
                    active_obj = this;

                    return false;
                };
            });

            return active_obj;
        };

        this.dom.$prdbut.on('click', _option + ' span[' + _value + ']', function () {
            var $btn = $(this);

            if($btn.hasClass('default')) return;

            var $pd = $btn.parents(_product),
                $option = $btn.parents(_option),
                is_act = $btn.hasClass('active'),
                obj = _self._methods._parseJSON($pd.attr(_obj)),
                variants_arr = obj[_variants] ? obj[_variants] : [],
                active_obj = {};

            if(is_act) {
                var default_id = obj[_default];

                $.each(variants_arr, function() {
                    if(this[_info]['id'] === default_id) {
                        active_obj = this;
                    }
                });

                active_obj['default'] = true;
            } else {
                var value = $btn.attr(_value),
                    group = $option.attr(_group),
                    current_obj = _self._methods._parseJSON($pd.attr(_current)),
                    click_obj = {},
                    click_fit_arr = [];

                current_obj[group] = value;
                click_obj[group] = value;

                active_obj = activeVariant(current_obj, variants_arr);
                click_fit_arr = fitVariants(click_obj, variants_arr);

                if(!active_obj) active_obj = click_fit_arr[0];
            }

            _self.setVariant($pd, {
                active_obj: active_obj,
                click_fit_arr: click_fit_arr
            });
        });

        this.dom.$prdbut.on('change', _option + ' select', function () {
            var $select = $(this),
                $pd = $select.parents(_product),
                $option = $select.parents(_option),
                obj = _self._methods._parseJSON($pd.attr(_obj)),
                variants_arr = obj[_variants] ? obj[_variants] : [],
                active_obj = {};

            var value = $select.find('option:selected').attr(_value),
                group = $option.attr(_group),
                current_obj = _self._methods._parseJSON($pd.attr(_current)),
                click_obj = {},
                click_fit_arr = [];

            current_obj[group] = value;
            click_obj[group] = value;

            active_obj = activeVariant(current_obj, variants_arr);
            click_fit_arr = fitVariants(click_obj, variants_arr);

            if(!active_obj) active_obj = click_fit_arr[0];

            _self.setVariant($pd, {
                active_obj: active_obj,
                click_fit_arr: click_fit_arr
            });
        });

        function imageHover(first_replace) {
            var $this = $(this),
                $pd = $this,
                $img = $this.find(_image + ' img'),
                src = $this.attr('data-image-hover');

            $this.attr('data-image-hover', $img.attr('src'));

            $this[first_replace ? 'attr' : 'removeAttr']('data-image-replaced', true);

            if(first_replace) {
                $pd.css({ 'min-height': $pd.innerHeight() });
            } else {
                $pd.removeAttr('style');
            }

            _self.replaceImage($pd, src, false);
        };

        this.dom.$prdbut.on('mouseenter', '.tt-product[data-image-hover]:not([data-image-replaced])', function(e) {
            imageHover.call(this, true);
        });

        this.dom.$prdbut.on('mouseleave', '.tt-product[data-image-hover][data-image-replaced]', function(e) {
            imageHover.call(this);
        });

        this.addGallery();
    },
    addGallery: function($gallery) {
        var _self = this,
            _gallery = this.selector.gallery,
            _product = this.selector.product,
            $gallery = $gallery || this.dom.$prdbut.find(_gallery);

        if($gallery.productGallery && typeof $gallery.productGallery === 'function') {
            $gallery.productGallery('addFuncAfterChange', function(fotorama, switchActTrigger, index_id_obj) {
                if(!switchActTrigger) {
                    var $fotorama = fotorama.activeFrame.$stageFrame,
                        $pd = $fotorama.parents(_product),
                        index = fotorama.activeIndex,
                        image_id = index_id_obj[index];

                    _self.switchVariantByInfoProp($pd, 'image_id', image_id, { gallery: false });
                }
            });
        }
    },
    switchVariantByInfoProp: function($pd, prop, value, obj_update) {
        var _obj = this.attr.obj,
            _variants = this.settings.variants,
            _info = this.settings.variants_info,
            obj = this._methods._parseJSON($pd.attr(_obj)),
            fir_obj = {};

        if(Object.keys(obj).length) {
            if(prop && value) {
                var variants_arr = obj[_variants] ? obj[_variants] : [];

                $.each(variants_arr, function() {
                    if(this[_info][prop] && this[_info][prop] === value) {
                        fir_obj = this;
                    }
                });

                if(!Object.keys(fir_obj).length) {
                    var _default_id = this.settings.variant_info_default_id,
                        default_id = obj[_default_id];

                    $.each(variants_arr, function() {
                        if(this[_info]['id'] === default_id) {
                            fir_obj =  this;
                        }
                    });
                }
            }

            if(!value || !prop || !Object.keys(fir_obj).length) {
                fir_obj[_info] =  this._methods._cloneObj(obj, _variants);
            }

            this.setVariant($pd, {
                active_obj: fir_obj
            }, obj_update);
        }
    },
    switchVariantByUrlId: function(obj_update) {
        var _product = this.selector.product,
            _product_page = this.selector.product_page,
            $pd = $(_product + _product_page);

        if(!$pd.length) return;

        var urlObj = this._parseUrl(),
            prop = 'id',
            value = urlObj.variant ? urlObj.variant : null;

        this.switchVariantByInfoProp($pd, prop, value, obj_update);
    },
    setVariant: function($pd, data, obj_update) {
        if(!data.active_obj) return;

        var _self = this,
            _option = this.selector.option,
            _options_select = this.selector.option_select,
            _selected = this.attr.variant_selected,
            _current = this.attr.variant_current,
            _value = this.attr.option_value,
            _info = this.settings.variants_info,
            $options_all = $pd.find(_option),
            $options_not_select = $options_all.not(_options_select),
            $options_select = $options_all.filter(_options_select),
            $options_all_span = $options_all.find('span[' + _value + ']'),
            $options_all_option = $options_select.find('option[' + _value + ']'),
            active_obj = data.active_obj,
            current_obj = this._methods._cloneObj(active_obj, _info),
            click_fit_arr = data.click_fit_arr || [];

        $options_all_span.removeClass('default');
        if(active_obj['default'] && active_obj['default'] === true) {
            obj_update = $.extend({}, { url: 'remove' }, obj_update);
            this._toggleState($options_not_select, 'span', active_obj, 'addClass', 'default');
        }

        $pd.attr(_selected, true);

        if(!click_fit_arr.length) click_fit_arr.push(active_obj);

        $options_all_span.addClass('disabled');
        $.each(click_fit_arr, function() {
            _self._toggleState($options_not_select, 'span', this, 'removeClass', 'disabled');
        });

        $options_all_span.removeClass('active');
        this._toggleState($options_not_select, 'span', active_obj, 'addClass', 'active');

        $options_all_option.removeAttr('selected');
        this._toggleState($options_select, 'option', active_obj, 'prop', 'selected', true);

        if(active_obj[_info]) this.replacePdInfo($pd, active_obj[_info], obj_update);

        this._methods._setAttrObjJSON($pd, _current, current_obj);
    },
    _toggleState: function($options_all, elem, obj, act, state, state_value) {
        var  _group = this.attr.option_group,
            _value = this.attr.option_value,
            _info = this.settings.variants_info;

        $.each(obj, function(k, v) {
            if(k === _info) return;

            $options_all.filter('[' + _group + '="' + k + '"]').find(elem + '[' + _value + '="' + v + '"]')[act](state, state_value);
        });
    },
    _parseUrl: function() {
        var _get = this.settings.variant_get_param,
            url = location.href,
            urlSplit = url.split('?' + _get + '='),
            urlObj = {
                product: urlSplit[0]
            };

        if(urlSplit[1]) urlObj.variant = urlSplit[1];

        return urlObj;
    },
    replacePdInfo: function($pd, obj, obj_update) {
        var _id = this.attr.variant_id,
            _check_wsl = this.attr.check_wsl,
            _check_cart = this.attr.check_cart,
            _wsl_add = this.selector.wsl_add,
            _wsl_toggle = this.selector.wsl_toggle,
            _cart_add = this.selector.cart_add,
            _cart_toggle = this.selector.cart_toggle,
            _btns_wsl_add = _wsl_add + ', ' + _wsl_toggle,
            _btns_cart_add = _cart_add + ', ' + _cart_toggle,
            $body = this.dom.$body,
            cart_obj = this._methods._parseAttr($body.attr(_check_cart)),
            wsl_obj = this._methods._parseAttr($body.attr(_check_wsl)),
            is_pd_page = $pd.hasClass(this.settings.product_page_class);

        if(is_pd_page) {
            obj_update = $.extend({
                id: true,
                image: true,
                gallery: true,
                btn_cart: true,
                btn_wsl: true,
                visible: true,
                elem: true,
                url: true
            }, obj_update);
        } else {
            obj_update = $.extend({
                id: true,
                image: true,
                btn_cart: true,
                btn_wsl: true,
                visible: true,
                elem: true
            }, obj_update, {
                gallery: false,
                url: false
            });
        }

        if(obj_update.id) {
            $pd.attr(_id, obj['id']);
            $pd.find('input[name="id"]').prop('value', obj['id']);
        }
        if(obj_update.image) {
            this.replaceImage($pd, obj['image']);
            if(obj['image']) {
                $pd.removeAttr('data-image-hover');
                $pd.removeAttr('style');
            }
        }
        if(obj_update.gallery) this.switchGallery($pd, obj['image_id']);
        if(obj_update.btn_cart) this.checkBtn($pd, obj['id'], cart_obj, _btns_cart_add);
        if(obj_update.btn_wsl) this.checkBtn($pd, obj['id'], wsl_obj, _btns_wsl_add);
        if(obj_update.url) this.replaceUrl(obj['id'], obj_update.url);
        if(obj_update.elem) this.replaceElem($pd, obj);
        if(obj_update.visible) this.checkVisible($pd, obj);

        Mogo.currency.update();

        Mogo.countdown($pd.find('.tt-countdown'));
    },
    checkVisible: function($pd, obj) {
        var _visible = this.attr.visible_elem,
            _info_visible = this.settings.variants_info_visible,
            _disabled = this.settings.visible_disabled_class,
            $visible = $pd.find('[' + _visible + ']');

        $visible.each(function() {
            var $elem = $(this),
                prop = $elem.attr(_visible),
                value,
                reverse = prop.charAt(0) === '!';

            if(reverse) prop = prop.slice(1);

            value = (obj[_info_visible][prop] && obj[_info_visible][prop] === true) ? true : false;

            if(reverse) value = !value;

            if(value) $elem.removeClass(_disabled);
            else $elem.addClass(_disabled);
        });
    },
    replaceElem: function($pd, obj) {
        var _replace = this.attr.replace_elem,
            _info_replace = this.settings.variants_info_replace,
            _disabled = this.settings.visible_disabled_class,
            $replace = $pd.find('[' + _replace + ']');

        $.each($replace, function() {
            var $elem = $(this),
                $replaceElem,
                prop = $elem.attr(_replace);

            if(obj[_info_replace][prop]) $replaceElem = $(obj[_info_replace][prop]);
            else $replaceElem = $('<span>').addClass(_disabled);

            $elem.replaceWith($replaceElem.attr(_replace, prop));

            $elem.off().remove();
        });
    },
    replaceUrl: function(id, act) {
        if(!id) return;

        var _get = this.settings.variant_get_param,
            url = this._parseUrl().product;

        if(act !== 'remove') url += '?' + _get + '=' + id;

        history.pushState({foo: 'bar'}, url, url);
    },
    replaceImage: function($pd, src, preloader) {
        if(!src) return;

        if(preloader === undefined) preloader = true;

        var _image = this.selector.image,
            $image = $pd.find(_image);

        if(!$image.length) return;

        var $image_tag = $pd.find('img');

        $image.height($image.innerHeight());

        if(preloader) {
            $image.addClass('ttg-loading');
        }

        var $img = $('<img>').attr('alt', $image_tag.attr('alt')).attr('src', src);

        $img.on('load', function () {
            $image_tag.replaceWith($img);
            $image.removeClass('ttg-loading').removeAttr('style');
            $image_tag.remove();
        });
    },
    switchGallery: function($pd, image_id) {
        var _gallery = this.selector.gallery,
            $gallery = $pd.find(_gallery);

        if(!$gallery.length) return;

        $gallery.productGallery('switchImageById', image_id);
    },
    checkBtn: function($pd, id, obj, btn) {
        if (!obj) return;

        var $btn = $pd.find(btn),
            present = false;

        $.each(obj, function(i, v) {
            if(+v === +id) {
                present = true;
                return false;
            }
        });

        if(present) this.state($btn, 'active');
        else this.state($btn, 'default');
    },
    _tocartHandlers: function() {
        var _self = this,
            $body = this.dom.$body,
            _product = this.selector.product,
            _cart_add = this.selector.cart_add,
            _cart_del = this.selector.cart_del,
            _cart_toggle = this.selector.cart_toggle,
            _cart_count = this.selector.cart_count,
            _cart_notes = this.selector.cart_notes,
            _cart_clear = this.selector.cart_clear,
            _id = this.attr.variant_id,
            _selected = this.attr.variant_selected,
            _act_class = this.settings.btn_active_class,
            _check_cart = this.attr.check_cart,
            _btns_cart_add = _cart_add + ', ' + _cart_toggle;

        function removeActState(id) {
            var cart = _self._methods._parseAttr($body.attr(_check_cart));

            if(!cart) return;

            var $pd_by_id = _self.dom.$prdbut.find(_product + '[' + _id + '="' + id + '"] '),
                $cart_btn_all = $pd_by_id.find(_btns_cart_add),
                i = 0;

            _self.state($cart_btn_all, 'default');

            for(; i < cart.length; i++) {
                if(cart[i] === id) {
                    cart.splice(i, 1);
                }
            }

            $body.attr(_check_cart, cart.join(', '));
        };

        function addActState(id) {
            var cart = _self._methods._parseAttr($body.attr(_check_cart));

            if(!cart) return;

            cart.push(id);

            $body.attr(_check_cart, cart.join(', '));
        };

        function addToCart($btn, e) {
            var $product = $btn.parents(_product),
                $form = $btn.parents('form'),
                serialize = $.extend({}, $form.serializeArray()),
                is_selected = $product.attr(_selected);

            if(is_selected) {
                _self.state($btn, 'wait');

                var id = $product.attr(_id),
                    $cart_count = $product.find(_cart_count),
                    $cart_notes = $product.find(_cart_notes),
                    notes = $cart_notes.length ? $cart_notes.val() : false,
                    data = {
                        id: id,
                        quantity: $cart_count.length ? $cart_count.val() : 1
                    };

                if(notes && notes !== '') {
                    data.properties = { 'Notes': notes };
                }

                $.each(serialize, function() {
                    if(this.name === 'notes' || this.name === 'id') return;

                    var objTree = this.name.split('.'),
                        value = this.value;

                    if(objTree.length > 1) {
                        var linkObj = data;

                        $.each(objTree, function(i, v) {
                            if(i < objTree.length - 1) {
                                if(linkObj.hasOwnProperty(v) && typeof linkObj[v] === 'object') {
                                    linkObj[v] = $.extend({}, linkObj[v]);
                                } else {
                                    linkObj[v] = {};
                                }

                                linkObj = linkObj[v];
                            } else {
                                linkObj[v] = value;
                            }
                        });
                    } else {
                        data[this.name] = value;
                    }
                });

                Mogo.cart.addItem({
                    data: data,
                    $btn: $btn,
                    callback: function(data, state) {
                        if(state === 'abort') {
                            _self.state($btn, 'default');
                        } else {
                            _self.state($btn, 'active');

                            addActState(id);
                        }
                    }
                });

                e.preventDefault();
                return false;
            }
        };

        function removeFromCart($btn, e) {
            var $product = $btn.parents(_product),
                is_selected = $product.attr(_selected);

            if(is_selected) {
                _self.state($btn, 'wait');

                var id = $product.attr(_id);

                Mogo.cart.removeItem(id, function(data) {
                    _self.state($btn, 'default');

                    removeActState(id);
                });

                e.preventDefault();
                return false;
            }
        };

        this.dom.$prdbut.on('click', _cart_add, function (e) {
            var $btn = $(this);

            addToCart($btn, e);
        });

        this.dom.$prdbut.on('click', _cart_toggle, function (e) {
            var $btn = $(this);

            if($btn.hasClass(_act_class)) {
                removeFromCart($btn, e);
            } else {
                addToCart($btn, e);
            }
        });

        this.dom.$prdbut.on('click', _cart_del, function (e) {
            var $btn = $(this);

            removeFromCart($btn, e);
        });

        this.dom.$prdbut.on('click', _cart_clear, function (e) {
            var $btn = $(this),
                is_check_cart = $body.attr(_check_cart) !== undefined ? true : false;

            _self.state($btn, 'wait');

            Mogo.cart.remove(function(data) {
                _self.state($btn, 'default');

                if(is_check_cart) {
                    var $pds = _self.dom.$prdbut.find(_product),
                        $cart_btn_all = $pds.find(_btns_cart_add);

                    _self.state($cart_btn_all, 'default');

                    $body.attr(_check_cart, '');
                }
            });

            e.preventDefault();
            return false;
        });

        if(!is_iframe) {
            this.dom.$prdbut.on('keyup customchange', _cart_count, $.debounce(350, function () {
                var $input = $(this),
                    $product = $input.parents(_product),
                    quantity = $input.val(),
                    id = $product.attr(_id);

                Mogo.cart.changeItem(id, quantity);
            }));
        }
    },
    _wishlistHandlers: function() {
        var _self = this,
            $body = this.dom.$body,
            _product = this.selector.product,
            _wsl_add = this.selector.wsl_add,
            _wsl_del = this.selector.wsl_del,
            _wsl_toggle = this.selector.wsl_toggle,
            _wsl_clear = this.selector.wsl_clear,
            _id = this.attr.variant_id,
            _handle = this.attr.handle,
            _act_class = this.settings.btn_active_class,
            _check_wsl = this.attr.check_wsl,
            _btns_wsl_add = _wsl_add + ', ' + _wsl_toggle;

        function removeActState(id) {
            var wsl = _self._methods._parseAttr($body.attr(_check_wsl));

            if(!wsl) return;

            var $pd_by_id = _self.dom.$prdbut.find(_product + '[' + _id + '="' + id + '"] '),
                $wsl_btn_all = $pd_by_id.find(_btns_wsl_add),
                i = 0;

            _self.state($wsl_btn_all, 'default');

            for(; i < wsl.length; i++) {
                if(wsl[i] === id) {
                    wsl.splice(i, 1);
                }
            }

            $body.attr(_check_wsl, wsl.join(', '));
        };

        function addActState(id) {
            var wsl = _self._methods._parseAttr($body.attr(_check_wsl));

            if(!wsl) return;

            wsl.push(id);

            $body.attr(_check_wsl, wsl.join(', '));
        };

        function addToWishlist($btn) {
            _self.state($btn, 'wait');

            var $product = $btn.parents(_product),
                id = $product.attr(_id),
                handle = $product.attr(_handle);

            Mogo.wishlist.addItem(id, handle, function(data) {
                _self.state($btn, 'active');

                addActState(id);
            });
        };

        function removeFromWishlist($btn) {
            _self.state($btn, 'wait');

            var $product = $btn.parents(_product),
                id = $product.attr(_id),
                handle = $product.attr(_handle);

            Mogo.wishlist.removeItem(id, handle, function(data) {
                _self.state($btn, 'default');

                removeActState(id);
            }, $product);
        };

        this.dom.$prdbut.on('click', _wsl_add, function (e) {
            var $btn = $(this);

            if(!$btn.hasClass(_act_class)) {
                addToWishlist($btn);
            }

            e.preventDefault();
            return false;
        });

        this.dom.$prdbut.on('click', _wsl_toggle, function (e) {
            var $btn = $(this);

            if(!$btn.hasClass(_act_class)) {
                addToWishlist($btn);
            } else {
                removeFromWishlist($btn);
            }

            e.preventDefault();
            return false;
        });

        this.dom.$prdbut.on('click', _wsl_del, function (e) {
            var $btn = $(this);

            removeFromWishlist($btn);

            e.preventDefault();
            return false;
        });

        this.dom.$prdbut.on('click', _wsl_clear, function (e) {
            var $btn = $(this),
                is_check_wsl = $body.attr(_check_wsl) !== undefined ? true : false;

            _self.state($btn, 'wait');

            var $product = $btn.parents(_product);

            Mogo.wishlist.clear(function(data) {
                _self.state($btn, 'default');

                if(is_check_wsl) {
                    var $pds = _self.dom.$prdbut.find(_product),
                        $wsl_btn_all = $pds.find(_btns_wsl_add);

                    _self.state($wsl_btn_all, 'default');

                    $body.attr(_check_wsl, '');
                }
            }, $product);

            e.preventDefault();
            return false;
        });
    },
    _quickviewHandlers: function() {
        var _self = this,
            _product = this.selector.product,
            _qv = this.selector.qv,
            _handle = this.attr.handle;

        this.dom.$prdbut.on('click', _qv, function (e) {
            var $btn = $(this),
                $product = $btn.parents(_product),
                handle = $product.attr(_handle);

            _self.state($btn, 'wait');

            Mogo.quickview.show(handle, function() {
                _self.state($btn, 'default');
            }, $btn);

            e.preventDefault();
            return false;
        });
    },
    _eventHistory: function() {
        var _self = this;

        $(window).on('popstate', function() {
            _self.switchVariantByUrlId({ url: false });
        });
    },
    state: function($btn, state) {
        var is_process = $btn.hasClass(this.settings.btn_process_class),
            act_class = this.settings.btn_active_class;

        if($btn.length) {
            switch(state) {
                case 'wait': {
                    if(is_process) {
                        $btn.addClass('tt-btn__state--wait');
                    }
                    break;
                }
                case 'active': {
                    $btn.addClass(act_class);

                    if(is_process) {
                        $btn.removeClass('tt-btn__state--wait');
                        $btn.addClass('tt-btn__state--active');
                    }
                    break;
                }
                case 'default': {
                    $btn.removeClass(act_class);

                    if(is_process) {
                        $btn.removeClass('tt-btn__state--wait');
                        $btn.removeClass('tt-btn__state--active');
                    }
                    break;
                }
            }
        }
    },
    _methods: {
        _cloneObj: function (obj, ignoreProp) {
            var clone = {};

            for(var key in obj) {
                if(ignoreProp && key === ignoreProp) continue;

                clone[key] = obj[key];
            }

            return clone;
        },
        _sortByKey: function (obj) {
            var new_obj = {},
                keys = Object.keys(obj),
                i = 0;

            keys.sort();

            for (; i < keys.length; i++) {
                var k = keys[i];

                new_obj[k] = obj[k];
            }

            return new_obj;
        },
        _isEqual: function (obj1, obj2) {
            var str1 = JSON.stringify(this._sortByKey(obj1)),
                str2 = JSON.stringify(this._sortByKey(obj2));

            return (str1 === str2) ? true : false;
        },
        _parseAttr: function(attr) {
            if(attr !== undefined) return attr.length ? attr.split(', ') : [];
            else return false;
        },
        _parseJSON: function(str) {
            return (str && str.length) ? JSON.parse(str) : {};
        },
        _setAttrObjJSON: function($pd, attr, obj) {
            obj && Object.keys(obj).length ? $pd.attr(attr, JSON.stringify(obj)) : $pd.removeAttr(attr);
        }
    },
});

// =require mogo/testimonials.js
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

window.Mogo.countdown('.tt-comming-soon__countdown');
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.btnToggleBlock = function() {
    var breakpoint = 1024,
        anim_scroll_duration = 500,
        _offsetTop = '.tt-header[data-sticky="true"]',
        scrollMarginTop = 40;

    function open($btn, $elem) {
        var $focus = $($btn.data('focus')) || false;

        if($elem.hasClass('ttg-hidden')) $elem.hide().removeClass('ttg-hidden');

        $elem.slideDown({
            complete: function() {
                var wind_w = window.innerWidth,
                    desktop = wind_w > breakpoint,
                    header_h = 0,
                    $sticky = $(_offsetTop);

                if(desktop && $sticky.length) {
                    header_h = $sticky.height();
                }

                $('html, body').velocity( 'scroll' , {
                    offset: $elem.offset().top - header_h - scrollMarginTop,
                    duration: anim_scroll_duration,
                    complete: function () {
                        if ($focus && $focus.length) $focus.focus();
                    }
                });
            }
        });
    };

    function close($btn, $elem) {
        $elem.slideUp();
    };

    $(document).on('click', '[data-toggle-block]', function(e) {
        var $this = $(this),
            $elem = $($this.data('toggle-block')) || false,
            action = $this.data('action') || 'toggle';

        if($elem.length) {
            $elem.stop();

            if(action === 'toggle') {
                if($elem.hasClass('ttg-hidden') || !$elem.is(':visible')) {
                    open($this, $elem);
                } else {
                    close($this, $elem);
                }
            } else if(action === 'open') {
                open($this, $elem);
            } else if(action === 'close') {
                if($elem.is(':visible')) {
                    close($this, $elem);
                }
            }

            e.preventDefault();
            return false;
        }
    });

    $.each($('[data-toggle-block][data-url-exist]'), function() {
        var $this = $(this),
            str = $this.data('url-exist') || false;

        if(str && window.location.href.indexOf(str) !== -1) {
            $this.trigger('click');
        }
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

Mogo.productView = function() {
    var $view = $('.tt-product-btn-vw:not(.tt-collection-param)');

    if(!$view.length) return;

    var $control = $($view.attr('data-control')),
        $input = $view.find('input');

    $input.on('change', function () {
        var $this = $(this);

        $input.each(function () {
            var view = $(this).attr('data-view-class');

            $control.removeClass(view);
        });
        
        $control.addClass($this.attr('data-view-class'));
    });
};

/*================ Sections ================*/
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.ProductSection = (function () {

  function Section(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    this.onLoad();
  }

  Section.prototype = $.extend({}, Section.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    onLoad: function() {
      Mogo.stickyBlock.section.init();
      Mogo.productGLR.section.init();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);

      Mogo.stickyBlock.section.destroy();
      Mogo.productGLR.section.destroy();
    }
  });

  return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.HeaderSection = (function () {

	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.header';

		this.onLoad();
	}

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			Mogo.headerVariables.section.init();
			Mogo.logoCurtain.section.init();
			Mogo.stickyHeader.section.init();
			Mogo.megamenu.section.init();
			Mogo.headerDropdowns.section.init();
			Mogo.listDropdown.section.init();
			Mogo.search.section.init();
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);

			Mogo.logoCurtain.section.destroy();
			Mogo.stickyHeader.section.destroy();
			Mogo.megamenu.section.destroy();
			Mogo.headerDropdowns.section.destroy();
			Mogo.listDropdown.section.destroy();
			Mogo.search.section.destroy();
			Mogo.headerVariables.section.destroy();
		}
	});

	return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.FooterSection = (function () {
	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.footer';

		this.onLoad();
	}

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			Mogo.btnToTop.section.init();
			Mogo.newsletter.section.init();
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);

			Mogo.btnToTop.section.destroy();
			Mogo.newsletter.section.destroy();
		}
	});

	return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.RevSliderSection = (function () {
	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.revslider';

		this.onLoad();
	}

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			Mogo.revolutionSlider.section.init();
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);

			Mogo.revolutionSlider.section.destroy();
		}
	});

	return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.ScrollSliderSection = (function () {
    function Section(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        this.settings = {};
        this.namespace = '.scrollslider';

        this.onLoad();
    }

    Section.prototype = $.extend({}, Section.prototype, {

        /**
         * Handles change events from the variant inputs
         */
        onLoad: function() {
            Mogo.scrollSlider.section.init();
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);

            Mogo.scrollSlider.section.destroy();
        }
    });

    return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.CollectionSection = (function () {
    function Section(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        this.settings = {};
        this.namespace = '.footer';

        this.onLoad();
    }

    Section.prototype = $.extend({}, Section.prototype, {

        /**
         * Handles change events from the variant inputs
         */
        onLoad: function() {
            Mogo.stickyBlock.section.init();
            Mogo.section.collection.init();
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);

            Mogo.stickyBlock.section.destroy();
            Mogo.section.collection.destroy();
        }
    });

    return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.BrandSection = (function () {
	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.home-brands';

		this.onLoad();
	}

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			Mogo.carouselBrands.section.init();
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);

			Mogo.carouselBrands.section.destroy();
		}
	});

	return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.CarouselBoxSection = (function () {

  function Section(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.carousel-box';

    this.onLoad();
  }

  Section.prototype = $.extend({}, Section.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    onLoad: function() {
      Mogo.carouselBox.section.init(this.$container);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);

      Mogo.carouselBox.section.destroy(this.$container);
    }
  });

  return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.InstagramSection = (function () {

  function Section(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.instagram';

    this.onLoad();
  }

  Section.prototype = $.extend({}, Section.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    onLoad: function() {
      Mogo.instafeed.section.init(this.$container);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);

      Mogo.instafeed.section.destroy(this.$container);
    }
  });

  return Section;
})();

/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */

theme.TestimonialsSection = (function () {

  function Section(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.testimonials';

    this.onLoad();
  }

  Section.prototype = $.extend({}, Section.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    onLoad: function() {
      Mogo.testimonials.section.init(this.$container);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);

      Mogo.testimonials.section.destroy(this.$container);
    }
  });

  return Section;
})();


$(function() {
  $('style.min-styles').remove();

  var sections = new slate.Sections();
	sections.register('header', theme.HeaderSection);
	sections.register('product', theme.ProductSection);
    sections.register('footer', theme.FooterSection);
	sections.register('revolution-slider', theme.RevSliderSection);
	sections.register('scroll-slider', theme.ScrollSliderSection);
	sections.register('sidebar', theme.CollectionSection);
	sections.register('home-brands', theme.BrandSection);
	sections.register('home-products-col', theme.CarouselBoxSection);
	sections.register('home-blog', theme.CarouselBoxSection);
	sections.register('home-instagram', theme.InstagramSection);
	sections.register('home-testimonials', theme.TestimonialsSection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }


	// Not sure. TODO rework to invoke only needed JS
	for(var key in window.Mogo) {
		if(typeof window.Mogo[key] === 'function') {
			window.Mogo[key]();
		} else if (window.Mogo[key].init && typeof window.Mogo[key].init === 'function') {
			window.Mogo[key].init();
		}
	}

	$(window).trigger('mogo.load');
});
Shopify.Cart.ShippingCalculator.show( {
  submitButton: theme.strings.shippingCalcSubmitButton,
  submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
  customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
  moneyFormat: theme.strings.shippingCalcMoneyFormat
} );